const cabinetOrigin = process.env.VUE_APP_CABINET_ORIGIN.toUpperCase()

export default {
	//login home page
	loginHeader: {
		contactUs: '联系我们',
	},
	loginPage: {
		instructionstitle1: '我们为您提供保障！',
		instructionstitle2: '满足您所有需求的解决方案',
		instructionstitle3: '',
		options1f: '访问您的账户',
		options1l: '',
		options2f: '进入您的 IB 门户',
		options2l: '',
		options3f: '浏览 Prop 报告',
		options3l: '',
		termsAndConditions: '条款与条件',
		privacyPolicy: '隐私政策',
		amlPolicy: '反洗钱政策',
		refundPolicy: '退款政策',
		riskDisclosure: '风险披露',
		complaintsProcedure: '投诉程序',
		cookiePolicy: 'Cookie 政策',
		userError: '输入的密码不正确，请检查并重试。',
		userErrorTwo: '输入的电子邮件未注册。请检查后再试。',
		enterCodeBelow: '在下面的框中输入您的身份验证应用程序提供的代码。',
		enterYourCode: '输入您的 2FA 代码',
		authCode: '身份验证代码',
		loginMobile: '登录您的帐户',
		loginOr: '或使用您的凭据登录：',
	},

	wellcomeComponent: {
		title: '感谢您的关注',
		titlesub: '让我们开始您的申请',
		subTitle: '请准备号您的开户和验证身份所需的信息。',
		before: '在开始之前，请准备以下文件：',
		government: '• 政府颁发的带照片的身份证件',
		proof: '• 居住证明',
		signature: '• 数字签名',
		agree:
			'*我同意让 Tradeview Financial Markets S.A.C. 通过提供我的个人信息（包括身份证件）以电子方式验证我的身份。 该信息将与受信任的身份验证服务提供商共享，以确认其准确性并将其与他们持有或从其他可靠来源获取的数据进行匹配。',
		agreeLATAM:
			'*我同意让 Tradeview Financial Markets S.A.C. 通过提供我的个人信息（包括身份证件）以电子方式验证我的身份。 该信息将与受信任的身份验证服务提供商共享，以确认其准确性并将其与他们持有或从其他可靠来源获取的数据进行匹配。',
		btnContinue: '继续',
		btnGoBack: '返回',
		btnConfirm: '确认',
		checkError: '选中该框以同意信息处理。',
	},

	loginBox: {
		title: '登录您的帐户',
		logInGoogle: '使用谷歌账户注册',
		logInFacebook: '使用 Facebook账户注册',
		or: '或使用您的凭据登录：',
		email: '电子邮件',
		placeholderEmail: '输入你的电子邮箱',
		placeholderPassword: '输入您的密码',
		password: '暗号',
		submit: '继续',
		forgot: '忘记密码？',
		doNotAccount: '没有账户？',
		signUp: '注册',
		tryFreeDemo: '试用免费演示',
		remember: '记住我',
		emailError: '请输入您的电子邮件',
		passwordError: '请输入您的密码',
		passwordToEmail: '请检查您的电子邮件',
		passwordToEmailDesc: '我们已向您发送重置账户的临时密码。',
	},

	forgotPage: {
		instructionstitle1: '这是满足您所有交易需求的平台',
		instructionstitle2: '为您争分夺秒！',
		instructionstitle3: '',
		options1f: '受监管且安全',
		options1l: '',
		options2f: '个性化协助',
		options2l: '',
		options3f: '无与伦比的流动性',
		options3l: '',
	},

	forgotBox: {
		title: '重置您的密码',
		email: '电子邮件',
		text1: '在下方输入您的注册电子邮件，我们将发送给您...',
		text2: '重置密码的说明。',
		placeholderEmail: '输入你的电子邮箱',
		badFormatEmail: `请确保您输入的电子邮件格式有效。例如 username@mail.com`,
		badEmail: '请输入您的注册电子邮件',
		wrongEmail: '输入的电子邮件未注册。请检查并重试',
		continue: '继续',
		limitExceeded: '重置密码的说明。',
		requiredField: '此字段为必填项',
		goBackLogIn: '返回登录',
	},

	verifiCode: {
		title: '请确认你的邮件地址',
		text1: ' 我们已将激活码发送到您的注册电子邮件中。',
		text2: '请检查您的收件箱并输入下面的验证码。',
		label1: '验证码',
		label2: '请输入 6 位数码。例如 123456',
		label3: '输入的代码无效。 请再试一次。',
		submit: '提交',
		text3: '没有收到验证码',
		text4: '申请重新发送',
		alert1: '一次性验证码已发送到 ',
		alert2: '我们现在无法重新发送您的代码。 请再试一次。',
		alert3: '验证码错误，请重试。',
		error: ' 出了点问题。请联系我们的代表： {contactInfo}',
	},

	setPassword: {
		title: '设置新密码',
		text1: '请输入您的新密码， ',
		text2: '并确保它与之前使用的密码不同。',
		label1: '新密码',
		label2:
			'密码须包含至少 8 个字符，其中至少包括1个小写字母、1个大写字母、1个数字和1个特殊字符。',
		label3: '确认密码',
		placeholder1: '输入您的新密码',
		placeholder2: '确认您的新密码',
		error1:
			'密码须包含至少 8 个字符，其中至少包括1个小写字母、1个大写字母、1个数字和1个特殊字符。',
		error2: '输入的密码不匹配。 请仔细检查并重试',
		description:
			'我们已向您注册的电子邮件发送了激活码。请检查您的收件箱并在下面输入。确认激活码后，请输入您的新密码，并确保它与之前使用的密码不同。',
	},

	setPasswordSuccess: {
		title1: '您的密码已成功重置！',
		title2: '',
		login: '登录',
	},

	consoleHeader: {
		account: '帐户 #',
		balance: '余额',
		equity: '账户净值',
		free: '可用保证金',
		margin: '保证金水平',
		status: '状态',
		hello: '你好',
		logout: '登出',
		confirm: '确认',
		outModal: '您确定要退出登录吗？',
		yes: '是的',
		not: '不是',
		settings: '设置',
		areYouDone: '申请完成了吗？',
		areYouSure: '您确定要退出吗？ 任何未保存的更改都将丢失。',
		yesLogOut: '是的，退出',
	},

	// Platforms page
	platforms: {
		description:
			'在您的设备上轻松使用重要的交易工具和账户信息，无论是在旅途中还是在办公桌前，您都可以掌控一切。选择您想要的工作方式并下载最适合您的软件/应用程序。',
		mainTitle: '您想如何交易？',
		metatrader4: {
			desc1: '用户友好且可定制的界面',
			desc2: '快速执行速度实现高效交易',
			desc3: '轻松下订单',
			desc4: '有效的仓位管理',
			desc5: '价格变动可视化以做出明智的决策',
		},
		metatrader5: {
			desc1: '您设备上的主要交易工具和账户信息',
			desc2: '提醒以免错过市场重要事件',
			desc3: '支持自动交易',
			desc4: '超过 80 个内置指标和分析工具',
			desc5: '用于增强交易策略的高级工具',
		},
		cTrader: {
			desc1: '直接进入货币市场',
			desc2: '直接进入货币市场',
			desc3: '轻松下单',
			desc4: '市场深度可见性，有助于做出明智的决策',
			desc5: '先进技术助力交易',
		},
		sterling: {
			desc1: '可定制的布局和快捷键',
			desc2: '一级、二级实时市场信息',
			desc3: '持仓及盈亏实时监控',
			desc4: '可定制的股票观察列表，每个代码包含 60 多个数据点',
			desc5: '超过 90 项研究和指标图表包',
		},
		lightspeed: {
			desc1: '多种定位来源，价格各异',
			desc2: '基于预配置设置的可定制订单',
			desc3: '复杂策略的期权订单表格',
			desc4: '可定制的监视列表和热键，用于快速输入订单',
			desc5: '全面的风险管理设置',
		},

		takion: {
			desc1: '多种图表类型、时间范围和技术指标。',
			desc2: '直接交易与市场准入以提高效率',
			desc3: '实时市场扫描和新闻更新',
			desc4: '二级实时和销售数据。',
			desc5: '用于无缝交易操作的多层工作区',
		},

		das: {
			desc1: '高级订单类型和实时图表',
			desc2: '多账户管理',
			desc3: '可定制的热键用于快速输入订单',
			desc4: '美国主要交易所的低延迟订单验证',
			desc5: '实时市场数据访问',
		},

		api: {
			desc1: '直接高速连接到我们的交易服务器',
			desc2: '快速执行和平台定制',
			desc3: '完全控制提交和接收的数据',
			desc4: '多种市价单和限价单选项',
			desc5: '灵活的交易策略',
		},
		cqg: {
			desc1: '通过用户友好的界面简化交易',
			desc2: '使用单个用户 ID 轻松管理多个帐户',
			desc3: '实时策略分配，及时决策',
			desc4: '自动化处理，方便交易',
			desc5: '可通过网络平台和移动应用程序访问，在任何设备上进行交易',
		},
		thanksForYourInterest: '感谢您的关注',
		weWillContactYou: 'Tradeview 代表将很快与您联系，帮助您设置新的模拟账户',
		createAccountToDownload: '创建账户下载此平台',
		createAccount: '创建账户',
		platformNotCovered:
			'您现有的帐户不涵盖此平台。要安装和使用它，请创建专用于此市场和平台的帐户。',
		btn_downd: '下载',
		btn_launch: '登录网页版',
		btn_request: '根据要求下载',
		okay: '好的',
		continue: '继续',
		requestAccount: '申请一个帐户',
		disabledOptionAlert:
			'我们无法启动您的下载。 请在下载尝试之间等待 10 秒，然后重试。',
		modal_reminder: {
			title: '提醒',
			descript1: ' 您的下载正在进行中！ 要访问您的账户',
			descript2:
				'请使用我们通过电子邮件发送给您的登录信息。如果您尚未申请此平台的帐户，',
			descript3: '您可以立即或随时申请。',
			descript1sub: '要访问您的账户',
			descript2sub:
				'请使用我们通过电子邮件发送给您的登录信息。如果您尚未申请此平台的帐户，您可以立即或随时申请。',
		},
		modal_send: {
			title: '您的申请已经提交',
			descript: '感谢您的关注！我们将很快与您联系，协助您设置所选平台。',
		},
		acessPlatforms:
			'提醒：您需要一个帐户才能访问这些平台，您可以在此处申请一个帐户。 ',
		acessPlatformsContinue: '',
		webVersionModal: '启动网页版',
		toAccess:
			'要访问您的账户，请使用我们通过电子邮件发送给您的登录信息。如果您尚未申请此平台的帐户，您可以立即或随时申请。',
		selectTypeAccount: '请选择您要用于启动网页版的账户类型：',
		live: '真实账户',
		demo: '模拟账户',
		launch: '启动',
	},

	//History page
	history: {
		titleH: '您的交易历史',
		periodTimeL: '这段历史',
		periodTimeP: '所有历史',
		typeL: '类型',
		typeP: '选择类型',
		platformL: '平台',
		platformP: '选择平台',
		accountL: '交易账户',
		accountP: '帐号',
		fromL: '从',
		fromP: '月/日/年',
		toL: '到',
		toP: '月/日/年',
		clearBtn: '清除',
		exportBtn: '导出',
		getBtn: '过滤器',
		applyBtn: '申请',
		optionsAccounts: '选择您的交易账户',
		infoAlertD: '选择一个帐户以在此处查看其动向。',
		noHistoryYet1: '选定的账户过滤器',
		noHistoryYet2: '还没有历史记录',
		platformAlertD:
			' 请注意：只有 MT4、MT5 和 cTrader 平台的账户才会显示在下面的过滤器和表格中。 对于其他平台上的账户，您可以在各自平台内访问其交易历史记录。',
		accountTypeH: '帐户类型',
		accountTypeP: '选择账户类型',
		alertExport: '您的信息已成功导出',
		btnFilter: 'Filters',
		alertPlatforMobile:
			'注意：下面仅显示 MT4、MT5 和 cTrader 账户。您可以在相应平台内访问其他平台的交易历史记录。.',
		modalHeader: '您确定要退出吗？',
		modalDescription:
			'如果您现在退出，该过程将无法完成，并且您将失去已取得的所有进度。',
		btnModalCancel: '取消',
		btnModalYes: '是，我确定',
		filterbyactivity: '按活动类型过滤',
		accountTooltip: '与该交易相关的账号。在转账的情况下，图标',
		accountTooltip2: '代表进入您查询账户的转账，',
		accountTooltip3: '以及从您账户中转出的转账。',
		accountTooltipIn: '从此列中列出的源账户进入您查询账户的转账。',
		accountTooltipOut: '离开您查询账户并发送到此列中列出的目标账户的转',
		selectActivity: '选择活动',
	},

	// Withdraw page
	withdraw: {
		sourceAccount: '转出账',
		currency: '货币',
		currencyType: '货币类型',
		details: '收款银行详细信息',
		beneficiaryDetails: '收款银行详细信息',
		swiftt: '迅速',
		branch: '分行名称',
		branchCode: '分行名称',
		enterbranch: '输入您的分行代码',
		province: '省',
		city: '城市',
		bank: '星展银行',
		bankK: '银行',
		withdrawFunds: '提取您的资金',
		withdrawalMethod: '提款方式',
		withdrawalAmmount: '可提取金额',
		keepInMind: '提醒：',
		withdrawalCalendar:
			'介绍经纪商每月每个日历只能提款两次，最低提款金额为 100 美元或等值的基础货币。 同一个日历月内额外提款将收取 50 美元的手续费。',
		withdrawalMustMatchDeposit:
			'所选的提款方式必须与存款方式一致。 对于信用卡和数字钱包存款，提款金额不能超过原始存款金额。',
		beneficiaryName: '收款人姓名',
		bankAddress: '银行地址',
		enterBankAddress: 'Enter your bank address',
		enterBeneficiaryName: '输入您的受益人姓名',
		beneficiaryAddress: '受益人地址',
		enterBeneficiaryAddress: '输入您的收款人地址',
		enterYourAddress: '输入您的地址',
		accountNumber: '帐号',
		iban: '(IBAN)',
		enterAccountNumber: '输入您的帐号',
		bankName: '银行名',
		enterBankName: '输入您的银行名称',
		swiftCode: 'SWIFT代码',
		enterSwiftCode: '输入您银行的快捷代码',
		abaNumber: 'ABA 号码',
		enterAbaNumber: '输入您的银行 ABA 号码',
		sortCodeClabe: '排序代码/CLABE',
		enterSortCodeClabe: '输入您的排序代码/CLABE',
		referenceNumber: '参考编号',
		enterReferenceNumber: '输入您的参考号',
		associatedEmail: '关联的电子邮件帐户',
		associatedEmailLabel: '关联电子邮件',
		enterAssociatedEmailAccount: '输入您的关联电子邮件',
		doYouNeedIntermediary: '需要中介银行吗？',
		selectAnOption: '选择一个选项',
		pleaseSelectAnOption: '请选择一个选项',
		enterCashAmount: '输入现金金额',
		helperCashTransfer: '最低 $10 美元。超过 25,000 美元的转账需要人工审核。',
		intermediaryBank: '中介银行详细信息',
		intermediaryBankk: '中介银行名称',
		ifNeeded: '（如果需要）',
		intermediaryBankName: '中间银行名称',
		banescoAccountName: '账户名称',
		enterAccountName: '输入您的账户名称',
		enterBankName: '输入您的银行名称',
		clabe: 'CLABE',
		clabealias: '(账户号码)',
		enterclabe: '输入您的 CLABE',
		pesosAccount: '比索账户号码',
		enterIntermediaryBankName: '输入您的中转银行名称',
		intermediaryBankAddress: '中转银行地址',
		enterintermediaryBankAddress: '输入您的中转银行地址',
		ibanNumber: 'IBAN号码',
		enterIbanNumber: '输入您的 IBAN 号码',
		withdrawalCompleted: '最低 $10 美元。超过 10,000 美元的转账需要人工审核。',
		withdrawalIsComplet: '审核中的提款',
		withdrawalIsCompletDescription:
			'您的提款正在审核中。一旦提款程序完成，我们的团队将通过电子邮件与您联系。',
		withdrawalCompletedDescription:
			'您的资金将很快到账目标账户。处理时间取决于您选择的提款方式。',
		withdrawNotCompleted: '您的提款尚未完成',
		withdrawNotCompletedDescription:
			'我们在处理您的提款时遇到了问题。 请验证您的提款信息并重试。 如果问题仍然存在，',
		contactUs: '请联系我们。',
		goToMyAccount: '转至“我的账户',
		creditCardDetails: '信用卡信息',
		important: '重要提示：',
		withdrawalsExceeding:
			'超过您的初始存款金额的提款无法通过信用卡处理。 您只能使用此方法提取与初始存款相同的金额。 如需提取利润，请使用其他提取方式。',
		creditCardLastDigits: '信用卡最后 4 位数字',
		enterCreditCardLastDigits: '输入您信用卡的最后 4 位数字',
		netellerAccountDetails: 'Neteller 帐户详细信息',
		netellerComission:
			'存款和取款 2% - 如果资金保留 3 个月或更长时间或您满足最低手数要求，则可免除费用（请联系客户经理以获取手数计算方面的帮助）',
		skrillAccountDetails: 'Skrill 帐户详细信息',
		upholdAccountDetails: 'Uphold 帐户详细信息',
		bitwalletAccountDetails: 'Bitwallet  账户详细信息',
		upholdComission:
			'如果发送至 Uphold 帐户：无费用。 如果发送到其他加密钱包：TV 不收取费用，但 Uphold 收取以下费用：交易费 (1.05%)、网络费 (0.0003 BTC)、提款费 (0.0004 BTC)。',
		bitPayTitle: 'BitPay 帐户详细信息',
		destinationAccount: '转入账户',
		bitPayCommision:
			'加密货币处理器收取以下费用：交易费（1.05%）、网络费（0.0003 BTC）、提款费（0.0003 BTC）',
		needYourAuth: '我们需要您的授权：',
		confirmThoughtEmail:
			'提交此提款请求后，您需要通过您帐户中注册的电子邮件进行确认。',
		wallet: '钱包',
		enterYourWallet: '请输入您的钱包地址',
		enteryourEmailAccount: '输入你的电子邮箱',
		sticPayAccountDetails: 'SticPay 账户详细信息',
		voletAccountDetails: 'Volet  账户详细信息',
		interacAccountDetails: 'Interac e-Transfer 账户详细信息',
		fasapayAccountDetails: 'Fasapay账户信息',
		searchABank: '搜寻银行',
		searchAnAccount: '搜索帐户',
		ibanIfApplicable: '（IBAN，如果适用）',
		beneficiaryBankName: '受益人银行名称',
		enterBeneficiaryBankName: '受益人银行名称',
		enterYourProvince: '请输入您的省份',
		enterYourCity: '请输入您的城市',
		unionPayDetails: 'UnionPay 详情',
		jpayDetails: 'JPay账户详细信息',
		jpayAccountDetails: 'JPay账户详细信息',
		walletAndCrypto: '钱包和加密货币',
		walletAndCryptoAlert: '使用加密货币提款时，需支付 0.7% 的转换费。.',
		crypto: '加密货币',
		selectCrypto: '选择一种加密货币',
		tag: '标签',
		enter: '进入',
		cryptocurrency: '加密货币',
		enterCryptocurrency: '输入加密货币 ',
		otherCurrency: '其他加密货币',
		enterOtherCurrency: '输入其他加密货币',
		areYouSure: '您确定要退出吗？',
		ifYouLeaveNow:
			'如果您现在退出，该过程将无法完成，并且您将失去已取得的所有进度。',
		noStay: '不退出',
		yesLeave: '是的，退出',
		requestSubmited: '您的请求已提交！',
		reviewEmail: '请检查您的注册电子邮件。',
		unsuccessfulWithdraw: '您的提款尚未完成',
		reviewAgain: '请检查您的提款信息并重试。如果问题仍然存在， ',
		amountTryAgain: '金额超过可转帐金额。 再试一次。',
		amountTryAgainWithdraw: '金额超过可提取金额。 再试一次。',
		minimunAmount: '此方法的最低提款额为 10 美元。',
		minimunAmount100: '此方法的最低提款金额为 100 美元。',
		minimunAmount0: '此方法的最低提款金额为 0.00001 BTC 作为示例。',
		invalidEmail: '无效的电子邮件格式',
		invalidAccountNumber: '无效的账号格式',
		noAvailableOptions: '没有可用的选项',
		closeModal:
			'请注意，如果您选择立即离开，则不会保存任何进度。 如果您打算稍后转移资金，则需要重新开始',
		successWithdraw:
			'好消息！您的资金将很快到账目标账户。处理时间可能会因您选择的提款方式而有所不同。',
		fundCreditCard: '使用信用卡入金',
		selectMethod:
			'提款方式是指从您的账户中提取资金的可用选项。 您可以提款到您的银行账户、信用卡、数字钱包或加密钱包。',
		invalidCreditCardDigits: '无效的卡号数字',
		phone: '电话',
		enterYourPhone: '输入你的电话号码',
		invalidPhone: '电话号码格式无效',
		modalPreferences: '不要再次询问当前登录名',
		bankFee: '$35 USD',
		bankBranch: '银行分行',
		enterBankBranch: '输入您的银行分行',
		branchProvince: '分行省份',
		enterBranchProvince: '输入您的分行省份',
		branchCity: '分行城市',
		enterBranchCity: '输入您的分行城市',
		bankTransfer: '银行电汇',
		bankTransferOption: '请选择银行进行转账',
		creditCard: '信用卡',
		cryptoWallet: '加密钱包',
	},

	//Account Activity page
	accountActivity: {
		title: '账户活动',
		from: '从',
		to: '到',
		type: '类型',
		platform: '交易工具',
		placeholderAccount: '交易账户',
		account: '交易账户',
		get: '获取',
		row: '页面行数',
		download: '下载报告',
		back: '后退',
		confirm: '确认',
		close: '关闭',
		error: '错误！字段不能为空',
		errorTwo: '错误！您必须选择字段类型。',
		activityid: '活动ID ',
		platfomr: '平台',
		date: '日期/时间',
		activity: '活动',
		profit: '盈亏',
		timeSegmentation: '时间细分',
		timeFrame: '选择时间范围',
		selectType: '选择类型',
		selectMarket: '选择市场',
		tradingAccount: '选择您的交易账户',
		segmentation: '时间细分',
		segmentationPlaceholder: '选择时间范围',
		platformPlaceholder: '选择平台',
		alert: '您的信息已成功导出',
		infoYet: '您选择的过滤器无效，请再试。',
	},

	//tradingHistory
	tradingHistory: {
		title: '交易历史记录',
		from: '从',
		to: '到',
		type: '类型',
		platform: '平台',
		placeholderAccount: '交易账户',
		account: '帐户',
		get: '获取',
		row: '页面行数',
		download: '下载报告',
		back: '后退',
		confirm: '确认',
		close: '关闭',
		error: '错误！字段不能为空',
		errorTwo: '错误！您必须选择字段类型。',
		deal: '交易',
		entryTime: '入场时间',
		typr: '类型',
		simbol: '产品代码',
		volume: '交易量',
		entryPrice: '入场价',
		sl: 'S/L',
		tp: 'T/P',
		exitTime: '退出时间',
		exitPrice: '退出价',
		commision: '佣金',
		bankFee: '银行手续费',
		swap: '隔夜利息',
		profit: '盈亏',
		dateFrom: '年/月/日',
		dateTo: '年/月/日',
		openingTime: '开盘时间',
		openingPrice: '开盘价',
		stopLoss: '止损',
		takeProfit: '止盈',
		closingTime: '收盘时间',
		closingPrice: '收盘价',
		comission: '委员会',
		time: '时间',
	},

	//Transfer page
	transfer: {
		mainTitle: '资金转账',
		isBackValidation:
			'我们的团队必须审核您的转账以进行批准。这可能需要下一个工作日内最多24小时。',
		pleaseNote: '请注意：仅允许同一用户拥有的帐户之间进行转账',
		mena: {
			consentCheck:
				'通过勾选复选框，我明白我已请求将资金从一个 Tradeview Ltd. 账户转移到我自己的另一个 Tradeview Ltd. 账户。',
		},
		ltd: {
			consentCheck:
				'通过勾选复选框，我明白我已请求将资金从一个 Tradeview Ltd. 账户转移到我自己的另一个 Tradeview Ltd. 账户。',
		},
		latam: {
			consentCheck:
				'通过选中该复选框，我了解我已请求将资金从一个 Tradeview Ltd. 账户转移到我自己的另一个 Tradeview Ltd 账户',
		},
		markConsentCheck: '您需要确认复选框才能继续。',
		transferAmount: '可转账金额',
		transferCompleted: '您的转帐已完成',
		transferReview: '转账审核中',
		transferInCompleted: '您的转账尚未完成',
		transferInCompletedDescription:
			'我们在处理您的转账时遇到了问题。 请验证您的帐户信息并重试。 如果问题仍然存在，。',
		transferDescription: ' 您的资金很快就会存入您的目标账户。',
		transferDescriptionReview:
			'您的转账现正在审核中。转账完成后，我们的团队将通过电子邮件与您联系。',
		destinationAccount: '转入账户',
		minimunAmount: '此方法的最低可转账金额为 10 美元',
	},

	//Accounts
	accounts: {
		refresh: '刷新余额',
		liveAccounts: '真实账户',
		demoAccounts: '模拟账户',

		createLive: '+ 创建一个新的真实账户',
		createDemo: '+ 创建一个新的模拟账户 ',
		refresh: '刷新余额',
		createAccount: '创建一个新账户',
		createDemoAccount: '创建一个新的模拟账户 ',
		createLiveAccount: '创建一个新的真实账户',
		livee: '真实账户',
		demoo: '模拟账户',
		yourBalance: '您的余额',
		equityy: '账户净值',
		marginLevel: '保证金水平',
		freeMargin: '可用保证金',
		statuss: '状态',
		leveragee: '杠杆',
		credit: '贷款',
		phone: '电话',
		selectLeverage: '选择杠杆',
		noLiveAccount:
			'如果您没有真实账户，请选择一款适合您需求的产品并立即开始交易。',
		noDemoAccount: '您没有模拟账户。选择一个适合您需求的账户并开始测试交易。',
		tradingInstrument: '交易产品',
		tradingMethodTooltip:
			'交易市场是指您可以参与的各种市场类型。通常称为证券，包括商品期货、股票、差价合约、货币、金属等等。不确定选择哪个市场？ 您可以在这里查看。',
		here: '这里',
		selectAMarket: '选择市场',
		platform: '平台',
		selectAPlatform: '选择平台',
		cashAmount: '现金金额',
		selectCashAmount: '选择现金金额',
		accountType: '帐户类型',
		selectAnAccount: '选择账户类型',
		currencyy: '货币类型',
		selectACurrency: '选择货币类型',
		platformTooltip:
			'交易平台是您用来在您的账户上执行交易的软件。不确定选择哪个平台？ 您可以在这里查看它们”',
		accountTypeTooltip:
			'账户类型允许您为您的账户选择交易条件（杠杆、点差、佣金）。',
		accountTypeTooltip2: '您可以在此处查看每种帐户类型的条件',
		applicationCompleted: '您的申请已完成！',
		applicationCompletedDescription:
			'您的真实账户申请目前正在接受审核，很快就会得到验证。 如果需要其他文件，我们的客服将与您联系。',
		applicationError: '您的申请未提交',
		applicationErrorDescription: '发送您的申请时发生错误信息。',
		applicationErrorDescription2:
			'我们的技术团队已获悉此问题。请重试，如果有问题请联系我们。',
		sureToLeave: '您确定要退出吗？',
		processUncompleted:
			'如果您现在退出，该过程将无法完成，并且您将失去已取得的所有进度。',
		cardPlatform: '平台',
		setDemoAccount:
			'我们正在设置您的新模拟账户。账户准备就绪后，您可以在此处找到所有详细信息。',
		cancel: '取消',
		active: '活跃的',
		accountSettings: '账户设置',
		changePw: '更改此账户的密码',
		changeLv: '更改此账户的杠杆',
		setLv: '设置您账户的新杠杆',
		underReview: '您的更新正在审核中',
		underReviewDesc:
			'您账户的新杠杆正在审核中，稍后将进行验证。我们的团队将在流程完成后通过电子邮件与您联系。',
		successLev: '您的杠杆已成功更新!',
		changePsw: '更改您的密码',
		forgotPw: '忘记密码？请{contact}。',
		updatePw: '您的密码已成功更新!',
		statusTooltip:
			'您的账户可能由于多种原因处于非活跃状态，例如缺少所需的信息或文件。请检查您的控制面板以获取任何警报。如果您不确定原因，请{contact}。',
		failedReq: '抱歉！发生错误',
		failedReqDesc: '请再试一次。如果问题持续，请{contact}寻求帮助。',
		forex: '外汇',
	},

	//CreateDemoAccounts
	demoAccounts: {
		login: '登录',
		pass: '密码',
		currencyTwo: '货币',
		server: '服务器',
		ilc: 'ECN账户',
		xleverage: 'xLeverage',
		dontForget:
			'在单击任何按钮或关闭此窗口之前，请不要忘记保存您的凭据。 此信息也将发送到您注册的电子邮件。',
		downloadCred: '下载',
		choosePlatform: '现在您可以选择并下载您的交易平台',
		ifYouChooseMT4:
			'如果您选择了 Mac OS 版 MetaTrader 4，请注意安装过程有所不同。 您可以在此处找到安装指南',
		ifYouChooseMT4Continuation: '',
		thanksForRegistering: '感谢您注册！',
		otherStock: 'Tradeview 代表将很快与您联系，帮助您设置新的模拟账户',
		stockMT52: '在设置您的帐户时，请随意浏览我们的网站。 ',
		stockMT53: '并了解有关 Tradeview 的更多信息。 ',
		stockMT54: '',
		accountTypeDemo:
			'账户类型允许您选择您的账户可以获得的杠杆 <br><br> 标准账户：1:400 <br> ECN账户：1:20 <br> 美股账户：1:1<br><br>不确定选择哪种帐户类型？ 您可以在这里查看</a>',
		applicationCompleted: '您的模拟帐户已创建！',
		pdfCredentialTitle: '尊敬的交易者',
		pdfCredentialDescription1: '感谢您选择我们来开启您的交易之旅。',
		pdfCredentialDescription2: '我们很高兴能与您一起踏上这段旅程。',
		pdfCredentialDescription3: '以下是您的账户凭证信息：',
		pdfCredentialEmail: '电子邮件：',
		pdfCredentialPassword: '密码：',
		pdfCredentialCurrency: '货币：',
		pdfCredentialServer: '服务器：',
		pdfCredentialInstructions: '说明：',
		pdfCredentialInstructions2: '使用您注册的电子邮件和密码',
		pdfCredentialTo: '来',
		pdfCredentiallogin: '登录',
		pdfCredentialTVAccount: '您的Tradeview账户。',
		pdfCredentialChangeP: '您可以在“设置”部分更改密码或设置双重认证',
		pdfCredentialSettings: '在柜台中的“设置”部分启用认证。',
		pdfCredentialFamiliarize: '请熟悉我们的平台，探索功能，',
		pdfCredentialExperience: '并开始体验Tradeview的与众不同。',
		pdfCredentialSupport: '我们在每一步都为您提供支持。如果您有任何问题',
		pdfCredentialNeed: '或需要帮助，请随时联系我们专门的',
		pdfCredentialTeam: '支持团队。',
		pdfCredentialHappy: '祝您交易愉快！',
		pdfCredentialRegards: '此致敬礼,',
		pdfCredentialTVTeam: 'Tradeview团队',
	},
	//Create Live Accounts
	liveAccount: {
		login: '登录',
		pass: '密码',
		server: '服务器',
		platform: '平台',
		status: '状态',
		statusFalse: '启用',
		statusTrue: '禁用',
		dontForget:
			'在单击任何按钮或关闭此窗口之前，请不要忘记保存您的凭据。 此信息也将发送到您注册的电子邮件。',
		downloadCred: '下载',
		applicationCompleted: '您的真实账户已创建！',
	},

	//credit card
	credit: {
		edit: '编辑',
	},

	//Banck Transfer add found Skrill
	addFounds: {
		amount: '金额',
	},

	//fidelity
	fidelity: {
		routingNum: '路由号码',
		swiftCodebic: 'SWIFT代码/BIC',
		disclaimer:
			'这些存款说明仅供开曼群岛居民使用。 如果您不是从开曼岛汇款，请使用其他银行。',
	},

	//Bbva
	bbva: {
		ruc: 'RUC',
		accountninfo: '0011-0351-0100035781',
		nameBenef: '受益人姓名',
		interbank: '银行同业编号 (CCI)',
	},

	//deposit
	deposit: {
		title: '选择入金方式',
		depositMethod: '入金方式',
		processingCards: '处理时间',
		fee: '费用',
		crypto: '加密货币',
		digitalWallets: '数字钱包',
		cardTransfer: '信用卡',
		wireTransfer: '电汇',
		btnDepositFunds: '存入资金',
		selectAnOption: '选择入金方式',
		depositCompleted: '您的存款已完成！',
		depositCompletedDescription:
			'您的资金将很快存入您的目标账户。处理时间取决于您选择的存款方式',
		despositInCompletedDescription:
			'我们在处理您的存款时遇到问题。 请验证您的付款信息并重试。 如果问题仍然存在，',
		contactUs: '联系我们',
		depositNotCompleted: '您的入金尚未完成',
		depositNotCompletedDescription:
			'请检查您的存款信息并重试。如果问题仍然存在，请联系我们。',
		depositWithClick: '或者只需点击或瞥一眼即可无缝存款。',
		keepInMind: '提醒：',
		keepInMindTC: '您在 24 小时内最多可以进行 5 笔交易。',
		ltd: {
			depositDisclaimer:
				'亏损可能超过初始投资金额。第三方存款将不被接受。所有存款必须由账户持有人进行。交易平台的计价货币为美元。Tradeview Ltd. 保留通过信用卡存入的资金选择退还/退款的权利，而不是处理提款。',
		},
		latam: {
			depositDisclaimer:
				'亏损可能超过初始投资金额。第三方存款将不被接受，所有存款必须由账户持有人进行。交易平台的计价货币为美元。Tradeview Financial Markets S.A.C. 保留选择退还通过信用卡存入的资金，而不是处理提款的权利。',
		},
		accountNumberTitle: '交易账号',
		accountNumberDescription: '选择您想要入金的交易账户',
		currencyTitle: '货币',
		currencyDescription: '选择货币类型',
		amountTitle: '金额',
		amountDescription: '输入现金金额',
		phoneNumberTitle: '电话号码',
		confirmTitle: '查看您的交易详细信息',
		confirmDescription: '请确保以下交易详细信息正确无误：',
		upholdCommission: '用户有责任支付加密货币交易费用。 费用值取决于转账金额。',
		upholdBanningTitle: '不接受入金的地区',
		upholdBanningDescription: 'Uphold 不向以下国家/地区的居民提供服务：',
		depositAmount: '请输入您的存款金额。',
		btcAlertTitle: 'BTC存款手续费',
		btcAlertMessage:
			'所有交易将收取BTC Fiat转换费。对于交易金额在25万美元以下的，手续费为1%；对于交易金额超过25万美元的，手续费为1.5%。',
		upholdWarningTitle: '直接将 BTC 存入 Tradeview',
		upholdWarningMessage:
			'对于 25 万美元以下的所有交易，BTC 法币兑换费为 1%，对于 25 万美元以上的所有交易，收取 1.5%',
		bitPayCommission: '加密货币交易费用由用户承担（费用根据转账金额而定）。',
		bitPayWarningTitle: '加密处理器收取以下费用：',
		bitPayWarningMessage:
			'兑换费：1.05%, 网络费用：0.0003 BTC, 提现费用：0.0003 BTC',
		bitpayFooterInfo:
			'请注意：Tradeview 对任何交易期间货币汇率的任何收益或损失不承担任何责任。',
		interacFooterInfo:
			'Tradeview Financial Markets S.A.C. 保留选择退还通过信用卡存入的资金，而不是处理提款的权利。',
		tetherWarningTitle: '佣金',
		tetherWarningMessage: '使用加密货币存款时需支付 0.7% 的转换费。',
		copied: '已复制！',
		tetherHashTitle: '哈希值',
		tetherHashDescription: '输入您的哈希值',
		tetherTooltip: '哈希是通过密码学随机生成的由数字和字母组成的代码。',
		netellerFooterInfo:
			'损失可能超过初始投资金额。 不接受第三方存款。 所有存款必须由账户所有者进行。 交易平台的面值是美元。Tradeview Ltd. 保留退回/退还通过信用卡存入的存款的权利，而不是处理提款。',
		fasapayAccountTitle: 'Fasapay 账户',
		fasapayAccountDescription: '请输入您的 FasaPay 账户 ID',
		jpayFooterInfo: '汇率：1 美元 = 7 人民币 (CNY)',
		addressTitle: '地址',
		zipCodeTitle: '邮政编码',
		zipCodeDescription: '输入您的邮政编码',
		countryTitle: '国家',
		countryDescription: '选择您所在的国家/地区',
		cityTitle: '城市',
		cityPlaceholder: '选择您的城市',
		skrillFooterInfo:
			'亏损可能超过初始投资金额。第三方存款将不被接受。所有存款必须由账户持有人进行。交易平台的计价货币为美元。Tradeview Ltd. 保留通过信用卡存入的资金选择退还/退款的权利，而不是处理提款。',
		bitwalletFooterInfo:
			'亏损可能超过初始投资金额。第三方存款将不被接受。所有存款必须由账户持有人进行。交易平台的计价货币为美元。Tradeview Ltd. 保留通过信用卡存入的资金选择退还/退款的权利，而不是处理提款。',
		clickBank:
			'点击您首选银行的名称以获取必要的账户信息，这将帮助您通过银行平台完成存款。转账完成后，请将交易凭证发送给您的经纪人以进行验证。验证后，您的资金将迅速添加到您的交易账户，确保过程顺畅高效。.',
		banks: '银行',
		processingTime: '处理时间:',
		commision: '佣金',
		bankProcessingTime: '处理时间：大约 1 至 2 个工作日。',
		bankCommision: '佣金：无o',
		sameDay: '当天处理',
		depositInstructions:
			'这些存款说明仅供开曼群岛居民使用。 如果您不是从开曼岛汇款，请使用其他银行。',
		downloadInfo: '下载信息',
		intermediaryBank: '中间银行名称',
		intermediarySwift: '中间人swift',
		beneficiarySwift: '收款人swift：',
		beneficiaryBank: '收款银行',
		paymentProvider: '付款提供商地址',
		accountHolder: '账户持有人姓名',
		virtualIban: '虚拟 IBAN',
		bic: 'BIC',
		createLiAcc: '创建真实账户',
		waitTitle: '正在加载新标签',
		waitDescription:
			'请不要关闭此窗口。将自动打开一个新标签以继续该过程。您可以继续浏览或在此等待。',
		depositTypeTitle: '选择存款类型',
		depositTypeDescription: '选择您喜欢的存款类型和相应的付款方式',
		typeCash: '现金支付',
		typeBankTransfer: '银行电汇',
		countryBankTitle: '付款方式',
		countryBankDescription: '选择付款方式',
		minimumAmount: '最低金额为',
		maximumAmount: '最高金额为',
		is: '是',
		pleaseNote: '请注意：',
		validateDeposit:
			'为验证您的存款，请在转账完成后将交易凭证发送给您的经纪人。验证完成后，您的资金将迅速添加到您的交易账户中，确保流程顺畅高效。',
		withdrawalchooseMatch: '您将来选择的提款方式必须与存款方式相匹配。',
		notResponsibleDuringTransactions:
			'Tradeview 对交易期间货币汇率变化造成的任何收益或损失概不负责。',
		minDeposit: '此方法的最低存款金额为 $100.00。',
		cryptos: {
			comission: {
				title: '佣金',
				text: 'Tradeview 不收取存款费用。我们的处理方收取 0.7% 的兑换费用。',
			},
			scanText1: '使用您的交易所中的扫描功能扫描此二维码',
			scanText2: '应用程序，或手动复制下面的加密地址：',
			copyText: '复制下面的加密货币地址，并粘贴到您的交易应用程序中：',
		},
		processTimeSameDay: '在同一天',
		processTimethreeDay: '最多 3 天',
		commisionYes: '是的',
		commisionNo: '不',
		onReviewTitle: '存款正在审核中',
		onReviewText:
			'您的存款现正在审核中。存款处理完成后，我们的团队将通过电子邮件与您联系。',
		minimumAndMaxiumAmountInterac: '最低 $75 加元 - 最高 $9,999 加元',
		routingNumber: '线路号码 (ABA)',
		beneficiaryBankAddress: '收款银行地址',
		beneficiaryAccountNumber: '受益人账号',
		beneficiaryAccountName: '受益人账户名称',
		paymentDetailsFFC: '付款详情 FFC',
		iban: 'IBAN',
		swiftBic: 'SWIFT/BIC',
		currencies: '货币',
		sortCode: '邮政编码',
		entersortCode: '请输入您的排序代码',
		beneficiary: '受益人',
		beneficiaryIBAN: '受益人 IBAN/账户',
		cci: 'CCI',
		moreInformationTitle: '需要额外信息',
		moreInformationText:
			'当您的存款总额达到25,000美元或以上时，需要进行一次额外验证。要完成存款，请点击“继续”并提供所需的工作和财务详细信息。',
		moreInformationTextLTD:
			'需要进行一次额外验证。要完成您的存款，请点击“继续”并提供所需的就业和财务信息。',
		selectMethod: '卡支付提供商',
		cryptoMena: '对于加密货币支付，此信息仅需要一次。',
		noOptions: '没有可用的选项',
		digitalWalletsDisclaimer:
			'• 损失可能超过初始投资金额。<br> • 不接受第三方存款。所有存款必须由账户持有人完成。<br> • 交易平台的货币单位是美元。',
		continueWithMyExchangeApp: '继续使用我的交易应用',
		continueWithPayX: '继续使用 PAY X',
		orDepositDirectly: '或者直接存款：',
		maximumAmountPSE_COL: '对于PSE支付方式，最高金额为600美元。',
		swiffyFooterInfo:
			'Tradeview Ltd. 保留退还/退款通过信用卡存款而非处理提款的权利。',
		payWith: '使用',
		typeOfCard: '卡片类型',
		debitCard: '借记卡',
		creditCard: '信用卡',
		continueAutoDeposit: '继续自动存款',
	},

	//Email
	email: {
		company: '公司新闻',
		selectOne: "交易新闻（ Surf's Up！）",
		selectTwo: "Surf's Up!",
		update: '更新',
		manageSubscription:
			'在这里管理您的订阅。 选择您希望接收品牌新闻通讯的主题：',
		dontReceiveEmails:
			'如果您不想再收到有关上述任何主题的电子邮件，只需取消选中它们即可。 不要忘记单击“更新”按钮。',
	},

	//password
	password: {
		title: '更改密码',
		subTitle: '要更改您的密码，请向您的电子邮件账户请求一次性验证码。',
		request: '请求代码',
		submit: '提交',
		code: '代码',
		current: '当前密码',
		confirm: '确认您的新密码',
		setPasswordPreference: '设置您的帐户首选项',
		mailingSubscriptions: {
			title: '您的邮件订阅',
			description:
				'在这里管理您的订阅。 直接在您的收件箱或公司信息中接收关键见解和分析，以了解最新动态。',
			subscriptionUpdated: '您的订阅已更新 ',
			subscriptionError: '哎呀！出现了问题，请联系客服。',
		},
		passwordSettings: {
			title: '您的密码设置',
			description:
				'管理您的密码设置以确保您的帐户安全。 在这里您可以随时更改它。',
		},
		factor2Verification: {
			title: '设置您的两步身份验证',
			description:
				'通过添加此协议来增强您的帐户安全性。 每次登录时都要求输入安全代码，以防止未经授权的访问您的帐户。',
			firstStepTitle: '第 1 步：下载身份验证应用程序',
			firstStepFirstParagraph:
				' 在您的移动设备上下载身份验证应用程序。我们建议在 Play Store 或 App Store 中搜索 Google Authenticator。',
			firstStepSecondParagraph:
				'当您启用两步身份验证 (2FA) 时，您将需要输入密码以及将显示在身份验证应用程序上的代码。',
			turnOn: '打开',
			secondStepTitle: '第2步：输入验证码',
			scanQRCode:
				'使用身份验证应用程序扫描以下二维码 输入身份验证应用程序中显示的六位数代码',
			enterCodeManually: 'E请输入身份验证应用程序中显示的六位数字代码',
			invalidCode: '输入的代码无效。 请再试一次。',
			authCompleted: '您在我们平台上的验证码已成功完成。',
			disable: '禁用',
			succesfullyActivatedAuth:
				'您已成功完成身份验证过程，为您的帐户添加了额外的安全层。 如果您决定更改这些设置，只需找到并单击“禁用”按钮即可。',
			deactivatedNotification: '您的2FA 代码身份验证已停用。',
			insertCode: '插入 2FA 代码',
			downloadAuth: '下载谷歌身份验证器',
			enterAuthCode: '输入您的验证码',
			codeSuccess: '我们平台上的代码已经成功',
		},
		accountPreferences: '您的帐户偏好设置',
		changeYoutPassword: '更改您的密码',
		requestChangePassword:
			'如果您想更改密码，您需要向您的注册电子邮件请求一次性代码。',
		requestCode: '请求代码',
		didntGetIt: '没明白？',
		tryAgain: '再试一次',
		enter6DigitCode: '输入 6 位数字代码。 例如。 123456',
		enterValidOTP: '输入的代码无效。 请再试一次。',
		notYourCurrentPassword: '这不是您当前的密码',
		passwordConditions:
			'密码须包含至少 8 个字符，其中至少包括1个小写字母、1个大写字母、1个数字和1个特殊字符。',
		passwordsDontMatch: '输入的密码不匹配。 请仔细检查并重试',
		newPassword: '新密码',
		confirmPassword: '确认密码',
		passwordSuccessfulyChanged: '你的密码已被成功更新。',
		sampleEmail: '一次性验证码已发送到',
		cantResendCode: '我们现在无法重新发送您的代码。 请再试一次。',
		enterCurrentPassword: '输入当前密码',
		enterNewPassword: '输入您的新密码',
		enterConfirmNewPassword: '确认您的新密码',
		passwordUpdated: '你的密码已被成功更新。',
		successful2Factor: '您的双因素身份验证已成功完成！',
		areYouSure: '您确定要禁用 2FA 吗？',
		changePasswordDescription:
			'更改您的帐户设置、管理您的订阅并确保您的帐户安全。',
	},

	//Contact
	contact: {
		requestCall: '请求通话',
		phoneNumber: '电话号码',
		preferedTime: '首选时间',
		selectPreferedTime: '选择您希望被呼叫的时间',
		enterPhone: '输入你的电话号码 ',
		knowMore: '了解更多关于我们',
		callSchedule: '您的通话已安排',
		callScheduleDescription:
			'我们的一位代理被指派接听您的电话后，我们会立即与您联系。请注意，此通话将在您提出请求后的从下一个工作日开始, 24 小时内进行。',
		failedToSchedule: '我们无法安排您的通话',
		weWillContactYou: '我们的一位服务代理将在您选择的时间范围内与您联系。',
		unableToContactYou:
			'很遗憾，我们目前无法安排通话。请仔细检查您的信息并重试。',
		infoInvalid: '提供的信息无效。请检查并重试。',
		inNeedOfHelp: '需要帮助吗？ 我们随时为您提供帮助！',
		inNeedOfHelpDescription:
			'无论您是需要有关请求的其他更新还是需要确认有关您帐户的详细信息，我们都会为您提供支持！ 请联系我们，我们将为您提供帮助。',
		chatDescription: '可选在线客服，我们的客服在24/7 全天候提供服务。',
		chatDescription1: '',
		mailForward: '请发送电子邮件告知您的问题或疑虑，我们会尽快回复您',
		emailUs: '给我们发电子邮件',
		letsChat: '请选在线客服',
		scheduleACall: '安排通话',
		contactDisclaimer: '可以直接加中文客服微信 tvcs02,',
		orVia: '或通过电子邮件发送至',
		contactDisclaimerLatam:
			'如果您愿意，您可以通过电子邮件直接联系我们，邮箱地址是...',
		stayConnected: '与我们保持联系',
		timeZone: '时区',
		selectTimeZone: '选择您的时区',
		customDate: '如果您愿意，您可以通过电子邮件直接联系我们，邮箱地址是...',
		soonAsPossible: '请尽快联系',
		callWhen: '我们什么时候应该给你打电话？',
		contactHelper:
			'请注意：我们安排的电话通话仅以英语进行。如果您选择“尽快”选项，我们将在下一个工作日的 24 小时内与您联系。',
		selectDate: '选择日期',
		selectTime: '选择时间',
		selectOption: '选择一个选项',
		preferredDate: '首选日期',
		sendEmail: '给我们发送电子邮件',
		subject: '主题',
		describeEmail: '描述您的电子邮件的目的',
		concerns: '在此处写下您的问题、疑虑或评论。',
		yourMessage: '您的消息',
		emailSuccessful: '您的电子邮件已成功发送！我们会尽快回复您。',
		emailSuccessfulTitle: '收到电子邮件',
		emailErrorfulTitle: '电子邮件传递问题',
		emailErrorMessage:
			'我们对不便表示抱歉。 请重试，如果问题仍然存在，请随时使用任何其他可用选项与我们联系。',
		japanNotice:
			'对于日本标准时区，仅在晚上 10:00 至凌晨 12:00 或早上 6:00 之间提供通话。对于给您带来的不便，我们深表歉意。',
		messageError: '消息不能超过 900 个字符',
		messageErrorShort: '消息必须至少有 15 个字符',
		titleError: '主题不能超过 60 个字符',
		titleErrorShort: '主题必须至少有 4 个字符',
		preferredDate: '首选日期',
		failedAttempt: '请稍后再试',
		callDate: ' 您的通话已安排',
		contactSetDate: '我们的客户经理将在您选择的日期和时间与您联系：',
		errorPhoneNumber: '电话号码不能包含字母或符号',
		callDescription: '需要联系我们吗？为您预约方便的时间！',
		errorCantNumber: '您输入的电话号码必须是 7 到 15 位数字。',
	},

	//menu
	menu: {
		appli: '应用程序',
		account: '账户',
		platforms: '下载',
		history: '历史',
		deposit: '订金',
		transfer: '转账',
		withdraw: '提款',
		tradingTools: '交易工具',
		settings: '设置',
		passwordsettings: '密码设置',
		emailsettings: '电子邮件设置',
		authenticationsettings: '认证设置',
		contactUs: '联系我们',
		accessDemo: '访问演示账户',
		accessRestricted: '访问受限',
		btnReSubmit: '重新提交文件',
		temporarilyUnavailable: '这些功能暂时不可用',
		sorryFeature:
			'抱歉，您尝试访问的功能尚不可用。一旦您完成申请流程并设置好账户，您将能够访问这些功能。',
		btnContinue: '继续',
		liveFeature: '这些是实时账户功能',
		featureOnly:
			'您尝试访问的功能仅适用于实时账户。现在创建一个实时账户以获取访问权限。',
		call: '没时间浪费？我们的支持团队在格林威治标准时间24/5随时待命。',
		chat: '喜欢聊天？我们可以这样做。我们的代理商在美国工作日24/7在线。',
		mail: '不那么紧急？给我们发送电子邮件，我们的专家会尽快回复您。',
		call2: '给我们打电话',
		chat2: '与我们聊天',
	},

	//sidebar applications process
	sidebar: {
		help: '需要帮忙？',
		call: '致电我们',
		chat: '与我们聊天',
		mail: '给我们发邮件',
		notReady: '还没有准备好开设真实账户吗？',
		btnDemo: '创建一个模拟账户',
	},

	//form signature
	formSignature: {
		authorised: '授权客户签名，在上面签名',
		or: '或',
		accept: '确认签名',
		error1: '您还没有签字，请签字。.',
		drop: '将您的文件拖放到此处或',
		browse: '浏览',
		make: '确保文件为JPEG、JPG或PNG格式且大小不超过3MB。',
		error_help: '您尚未上传带有您签名的文件，请上传。',
	},

	//Text of application process form
	applicationForm: {
		duplicateShareholder: '已存在具有相同名字和姓氏的股东。',
		duplicateEmail: 'A shareholder with this email already exists.',
		details: '详细信息',
		idVerification: '身份验证',
		proofResidence: '居住证明',
		proofResidenceConsent: 'Proof of residence and consent',
		consent: 'Consent',
		liveIndividual: '个人实盘账户',
		liveJointAccount: '联名实盘账户',
		primaryAccountHolder: '主要账户持有人',
		title: '个人资料',
		subtitlePlatform:
			'创建您的第一个 Tradeview 账户后，您可以轻松地为不同的金融资产开设更多账户，而无需再次填写整个表格。',
		subtitleDocument: '您希望使用哪种类型的文件进行验证？',
		subtitleResidence: '您希望使用哪种类型的居住证明进行验证？',
		subtitleExperience:
			'选择最能代表您的外汇、股票、期货、衍生品或差价合约交易经验的选项。',
		submitContact: '联系我们',
		drop: '将您的文件拖放到此处或',
		browse: '浏览',
		make: '确保文件为JPEG、JPG或PNG格式且大小不超过3MB。.',
		makeMaxSize: '确保文件为JPEG、JPG或PNG格式且大小不超过15MB。',
		tryAgain: '再试一次',
		openFile: 'Open File',
		submitted: '已提交申请：审核中',
		thankyou:
			'感谢您提交帐户申请。 您的请求目前正在接受审核，很快就会得到验证。',
		operations: '如果需要任何进一步的文件，我们的运营团队将与您联系。.',
		appreciate: ' 我们感谢您的合作，并将随时向您通报最新进展情况。',
		gotocabinet: '访问客户后台',
		explore: '浏览 Tradeview',
		acknowledgementText: '通过在下面签名，我承认并同意此流程上一步中列出的文件',
		acknowledgementTextLATAM:
			'在勾选同意框并签名之前，请仔细阅读并理解此页面上的每一项内容。',
		secondaryAccount: '附加副账户持有人',
		secondaryAccountDesc: '完成账户设置必须创建第二账户持有人。 ',
		primaryAccountHolder: '主要账户持有人（您:',
		secondaryAccountHolder: '副账户持有人：',
		corporateResol: '公司决议',
		corporateResolDisclaimer:
			'上传文件，请将文件放入字段中或使用图标进行浏览。',
		corporateResolDisclaimer2: '确保文件为JPEG、JPG或PNG格式且大小不超过3MB。.',
		corporateResolDesc:
			'您可以通过点击 {link} 下载并填写 Tradeview 的标准公司决议书，或者您也可以提供您自己的文件。',
		shareHolder: '添加股东',
		shareHolderDesc:
			'最多添加 9 位股东，每位股东至少持有 10% 的股份，或者跳过此步骤申请无股东的公司账户。',
		addShareholder: '添加新股东',
		or: '或',
		completeShareholder: '填写股东详细信息',
		shareholder: '股东',
		information: '信息',
		aboutToComplete: '您即将填写股东#{number}的信息',
		noShareAvailable: '股东和账户持有人的总百分比不能超过100%。请重试。',
		percentageLow: '股东和账户持有人的总百分比必须为100%。请核实。',
		aboutToCompleteDesc: '开始之前，请准备好股东#{number}的以下文件：',
		accountHolderDisclaimer:
			'对于持有公司超过{percentage}股份的股东，我们要求提供个人信息、身份证和地址证明。对于持有不到{percentage}股份的股东，我们只要求提供姓名和姓氏。',
		deleteShareholder:
			'要编辑股份或上传股东的身份证和地址证明，必须先删除现有条目，然后重新添加。',
		sendInvitation: '发送邀请',
		inviteSentSuccess: '邀请已成功发送',
		inviteSentSuccessDesc: '在股东信息部分跟踪每个股东的申请进度。',
		primaryHolder: '账户持有人（您）',
		sharePercent:
			'股份代表公司的所有权。 向股东分配百分比，以确定他们在公司结构中的所有权份额。',
		accountHolder: '账户持有人（您）',
		shareHolderDetails: '股东 {user} 详细信息：',
		continueNoShareholder: '没有股东的情况下继续',
		infoSwitchOff:
			'如果您所在司法管辖区有要求，我们的后台团队将来会向您提出要求。',
		fileNotValid: '请上传有效格式和大小的文件。',
		resolUpload:
			'确保文件中的信息和图像清晰易懂。 <br/><br/>请随意上传您目前拥有的文件。 如果有些内容丢失，请不要担心； 您可以稍后根据要求上传或发送 ',
		upDocument: '文件上传',
	},

	expiredDocument: {
		resubmit: '重新提交您的文件',
		settingsDesc:
			'通过在此处重新提交您的身份证明和/或地址证明文件，以确保操作顺畅。',
		resubmitDesc:
			'您的验证文件已过期。请立即或在接下来的 {days} 天内在您的柜台设置中上传新文件。如果您未能这样做，您将无法进行转账、取款或存款，直到文件更新。',
		idRefinitiv: '您想使用哪种身份验证方法？',
		idRefinitivDesc:
			'更新您的身份信息并提供政府签发的身份证明，以确保您账户的安全性和合法性。',
		idTooltip:
			'选择您想要如何完成身份验证。您可以使用手机扫描二维码，也可以在当前设备上继续。选择您喜欢的方法。',
		cancelModal: '您确定要退出吗？',
		cancelModalDesc:
			'请记住，您必须在接下来的 {days} 天内完成此步骤。如果未能这样做，您将无法使用您的柜台中的取款、存款和转账功能，直到所需的文件得到更新。',
		accessRestricted: '访问受限',
		uploadDocs: '上传您的文件',
		resubmitDocs: '重新提交文件',
		restrictedID:
			'我们在随机检查中注意到您提供的身份证明现在已过期。为了确保您的账户安全，我们已暂时封锁了您的转账、取款和存款功能。',
		restrictedID2:
			'请立即上传新的身份证明，以恢复访问权限并继续在您的柜台中享受顺畅的体验。',
		restrictedPOA:
			'我们在随机检查中注意到您提交的地址证明现已过期。为了确保您的账户安全，我们已暂时封锁了您的转账、取款和存款功能。',
		restrictedPOA2:
			'请立即上传新的地址证明，以恢复访问权限并继续在您的柜台中享受顺畅的体验。',
		restrictedBoth:
			'我们在随机检查中注意到您提交的身份证明和地址证明现已过期。为了确保您的账户安全，我们已暂时封锁了您的转账、取款和存款功能。',
		restrictedBoth2:
			'请立即上传新的文件，以恢复访问权限并继续在您的柜台中享受顺畅的体验。',
		restrictedLimited:
			'您的验证文件缺失。请上传以获取访问权限；在此之前，您的交易账户将保持受限状态。',
		confirmationLimited:
			'请记得完成此步骤。如果不执行，您的交易账户将在未上传文件前一直处于禁用状态。',
		alertExpiredDocsSuccess:
			'您已成功提交文件，当前正在审核中。如果需要进一步的文件，我们的团队会联系您。',
		alertExpiredDocsError: '请现在或在接下来的 {days} 天内上传新文件。',
		alertMissingDocsError: '请上传您的文件以启用您的交易账户。',
		submitDoc: '提交文件',
		idverseD:
			'身份验证过程对于防止欺诈、确保我们服务的合规使用至关重要。感谢您的配合！',
		idverseT:
			'选择您希望完成身份验证的方式。您可以使用手机相机扫描二维码，发送链接到您的手机，或者继续在当前设备上操作。',
	},

	//Aplication Process refinitiv
	appliProcessIDverse: {
		QRdescription: '使用手机的摄像头扫描二维码。',
		IDVerseTitle: '您想使用哪种身份验证方式？',
		IDVerseTitleLatam: '选择您偏好的身份验证方式',
		IDVerseTitleManualDoc: '选择您偏好的身份验证方式',
		IDVerseTitleManualDocTitle: '选择一种证件类型',
		IDVerseTitleManualDocDesc: '请选择您希望用于验证的证件类型：',
		IDVerseTitleManualDocMainDesc:
			'身份验证过程对于防止欺诈以及确保我们服务的负责任和合法使用至关重要。我们衷心感谢您的配合。',
		IDVerseDesc:
			'为了获得更顺畅的体验，我们建议您使用以下选项之一在手机上完成此步骤：',
		or: '或',
		verifyOnNewTab: '在当前设备上继续',
		sendLinkSms: '通过短信发送链接',
		verifyPopupConfig:
			'请确保您的浏览器弹出窗口拦截器已禁用。有关更多信息，请参见。',
		clickHere: '点击这里',
		alertDetail:
			'请注意，每个唯一链接只能访问验证过程一次。如果需要再次访问，请刷新页面，然后点击您偏好的验证方式。',
		alertDetailMobile:
			'请注意，每个唯一链接只能访问验证过程一次。要完成验证过程，请刷新页面并点击 `验证我的ID`。如果已经完成，请点击继续。',

		//Modal Verify Identity
		modalVerifyTitle: '验证您的身份',
		btnVerifyID: '验证我的身份',
		modalVerifyDesc1: '要继续，您必须完成身份验证过程。',
		modalVerifyDesc2: '如果您已完成身份验证但仍无法继续，请尽快联系我们。',
		modalVerifyButton: '选择一个身份验证方法',
		//Skip step
		modalSkipTitle: '您确定要跳过此步骤吗？',
		modalSkipDesc1:
			'您可以暂时跳过此步骤，并稍后在您的客户柜台完成，或者现在选择一种文件类型来完成流程。',
		modalSkipDesc2: '请注意，完成此步骤是激活您的交易账户的必要条件。',
		btnVerifyAddress: '验证我的地址',
		btnVerifyIdentity: '验证我的身份',
		btnSkip: '暂时跳过',
		matchMediaodalSendSMSChangeNumberTitle: '输入新的手机号码',
		modalSendSMSChangeNumberTitle: '输入新手机号 ',
		modalSendSMSChangeNumberDesc:
			'请输入您希望通过短信接收身份验证链接的手机号码。',
		modalSendSMSChangeNumberButton: '发送',
		modalSendSMSChangeNumberCancel: '取消',
		modalSendSMSChangeNumberCheck: '保存为我的注册手机号码。',
		modalSendLinkSMSFailedTitle: '发生错误',
		modalSendLinkSMSFailedDesc: '我们无法通过短信发送链接。请检查号码并重试。',
		modalSendLinkSMSFailedButtonCancel: '取消',
		modalSendLinkSMSFailedButtonChangeNumber: '更改号码',
		modalSendLinkSMSTitle: '链接已通过短信发送',
		modalSendLinkSMSDesc:
			'链接已发送到您注册的手机号码。请在手机上打开链接并按照步骤完成身份验证。',
		modalSendLinkSMSButtonReSend: '重新发送',
		modalSendLinkSMSButtonOkay: '好的',
		clickHere: '点击这里',
		or: '或',
		modalSendLinkSMSOptionalNumber: '发送到另一个手机号码',
		uploadCurrentDevice: '从您当前的设备上传您的文件。',
		retryIn: '请在以下时间后重试',
		chooseTooltip:
			'选择您希望完成身份验证的方式。您可以使用手机扫描二维码、通过短信发送链接到手机或在当前设备上继续。',
		sendToDifferentNumber: '发送到另一个手机号码',
		chromeInstructions: {
			step1: '前往设置。',
			step2: '导航到“隐私与安全” > “网站设置” > “弹出窗口和重定向”',
			step3: ' 关闭“阻止”选项',
		},
		safariInstructions: {
			step1: '前往 Safari > 偏好设置。',
			step2: ' 选择“网站” > “弹出窗口”',
			step3: ' 根据需要调整设置',
		},
		firefoxInstructions: {
			step1: '点击菜单图标。',
			step2: ' 前往“偏好设置” > “隐私与安全” > “权限”',
			step3: ' 根据需要调整弹出窗口设置。',
		},
		assistanceText: `如果遇到任何困难`,
		assistanceText2: `请联系我们寻求帮助。`,
	},

	//Application process CORPORATE form
	applicationFormCorporate: {
		liveCorporateAccount: '真实公司账户',

		//Company details
		companyDetailsTitle: '公司详情',
		nameLabel: '公司名称',
		namePlaceholder: '输入您的公司名称',
		businessTypeLabel: '业务类型',
		businessTypePlaceholder: '选择业务类型',
		companyEmailLabel: '公司邮箱',
		companyEmailPlaceholder: '输入公司电子邮件',
		companyEmailTooltip:
			'我们要求提供公司电子邮件以确保安全通信并验证公司帐户的合法性。 它帮助我们为您的企业维护一个安全可靠的交易环境。',
		businessDescriptionLabel: '业务描述',
		businessDescriptionPlaceholder: '输入公司规模及其提供的服务的简短描述。',
		businessDescriptionTooltip:
			'这有助于我们了解贵公司的活动和宗旨。 提供清晰的描述可确保帐户审批流程顺利，并帮助我们定制服务以满足您的业务需求。',

		//Company address
		companyAddressTitle: '公司地址',
		companyAddressTitleTooltip: `这是指您的业务主要所在的国家/地区。准确的信息有助于我们根据地区要求和法规定制我们的服务。如果选项中未列出您所在的国家/地区，我们很遗憾地通知您，我们无法在您所在的位置提供服务。`,

		//Account ownership
		accountOwnershipTitle: '账户所有权信息',
		dateIncorporationLabel: '注册成立日期',
		dateIncorporationTooltip:
			'这是您的公司正式注册的日期。提供此日期有助于我们验证您的业务的法律状态，并确保符合监管要求。',
		countryOfRegistrationLabel: '公司成立国家/地区',
		countryOfRegistrationPlaceholder: '选择一个国家',
		countryOfRegistrationTooltip:
			'这是您的公司正式注册的国家/地区。 提供此信息有助于我们了解您企业的法律管辖权，确保遵守地区法规。',
		marketCapitalizationLabel: '总市值或净资产',
		marketCapitalizationPlaceholder: '输入您公司的总市值',
		marketCapitalizationTooltip:
			'总市值包括公司已发行股票的整体市场价值，而净值则代表公司资产总值减去其负债后的总价值。',
		isSubsidiaryLabel: '如果是子公司，请提供母公司信息。',
		isSubsidiaryPlaceholder: '请输入母公司名称',
		isIndividualRegularMemberLabel:
			'填写此表格的个人是普通成员/合伙人，还是代表了在此关系中提到的实体的最终受益所有者？',

		//Tax residency information
		taxResidencyTitle: '税务居民身份申报',
		isUSCompanyLabel: '该公司是否被归类为美国实体或美国税务居民？',
		taxResidencyContryLabel:
			'该公司特此确认，出于税务目的，其是以下国家的居民：',
		taxResidencyContryListLabel: '国家',
		taxResidencyContryListPlaceholder: '选择一个国家',
		taxResidencyReferenceCodeLabel: '税务参考代码',
		taxResidencyReferenceCodePlaceholder: '输入您的税务参考代码',
		modalRegulationP:
			'很抱歉，由于监管原因，我们无法提供服务总部位于美国领土的公司或居住者。',

		//Account type and platform information
		accountTypeTitle: '帐户类型',

		// Financial details
		financialDetailsTitle: '财务细节',
		financialDetailsTooltip:
			'您需要披露公司的财务详细信息，以便为双方（公司和 Tradeview）妥善解决风险。',
		companyAnnualIncomeLabel: '公司的年收入/总营业额是多少？',
		companyAnnualIncomeTooltip:
			'公司的年收入或总营业额是指组织在特定时间段（通常为一年）内产生的总收入。',
		companyTotalAssetsLabel: '公司总资产余额是多少？',
		companyTotalAssetsTooltip:
			'公司的资产余额是公司的储蓄、投资、房地产扣除承诺后的价值。',
		companyLiquidAssetsLabel: '您的流动资产余额是多少？',
		companyLiquidAssetsTooltip:
			'您的流动资产余额是您的现金、货币、市场工具和有价证券的总和。',
		companyOriginAssetsLabel: '公司总资产的来源是什么？',
		companySourceFundsLabel: '公司的存款/资金来源是什么？',
		companyPruoseAccountLabel: '该帐户的目的是什么？',
		companyIsConnectedBanktruptcies: '该公司是否与破产有关？',
		companyIsConnectedBanktruptciesDetailsLabel: '破产详情',
		companyIsConnectedBanktruptciesDetailsPlaceholder:
			'包括与公司相关的破产信息。',
		companyIsConnectedBanktruptciesDetailsTooltip:
			'公司需要披露任何破产关联，以便处理公司和 Tradeview 双方的风险。然而，请放心，即使公司与破产有任何关联，仍然可以继续进行申请过程。',

		//Proof of address
		proofAddressTitle: '地址证明',
		proofAddressTitleCorporate: '公司地址证明',
		proofAddressDescription: '确认您的位置以确保符合监管标准。',

		//Company Account Consent
		companyAccountConsentTitle:
			'感谢您与我们分享您的公司详细信息。 让我们继续前进！',
		companyAccountConsentDescription1:
			'请填写帐户持有人的信息。您可以随时使用编辑所提供的详细信息 屏幕右侧的进度列表。 只需单击信息旁边的铅笔图标即可。',
		companyAccountConsentDescription2:
			'请注意，除了政府签发的带照片的身份证件和居住证明文件外，您可以在方便时上传必要的文件——现在或稍后根据要求上传。',
		companyAccountConsentDocumentsTitle:
			'开始之前，请确保您已准备好以下可供上传的文档：',
		companyAccountConsentDocumentsList1:
			'账户持有人的政府签发的带照片的身份证件',
		companyAccountConsentDocumentsList2: '账户持有人的居住证明',
		applicationFormAccountCheck:
			'我同意让 Tradeview Financial Markets S.A.C. 通过提供我的个人信息（包括身份证件）以电子方式验证我的身份。 该信息将与受信任的身份验证服务提供商共享，以确认其准确性并将其与他们持有或从其他可靠来源获取的数据进行匹配。',

		//Company Consent
		companyConsentTitle: '感谢您的关注！让我们开始您的申请',
		companyConsentDescription: '为了设置您的公司帐户，请准备以下信息',
		companyConsentDocumentsTitle: '在开始之前，请准备以下文件：',
		companyConsentDocumentsOfCompanyTitle: '公司',
		companyConsentDocumentsList1: '公司注册证书',
		companyConsentDocumentsList2: '公司地址证明',
		companyConsentDocumentsList3: '公司银行对账单',
		companyConsentDocumentsList4: '公司财务报表',
		companyConsentDocumentsList5: '公司税务证书',
		companyConsentDocumentsList6: '公司所有权结构',
		companyConsentDocumentsList7: '公司年度报告',
		companyConsentDocumentsOfAccountHolderTitle: '账户持有人',
		companyConsentDocumentsOfAccountHolderList1: '公司商业计划',
		companyConsentDocumentsOfAccountHolderList2: '公司营业执照',
		companyConsentDocumentsOfShareholderTitle: '最终受益人/股东：',
		companyConsentDocumentsOfShareholderList1: '公司股东协议',
		companyConsentDocumentsOfShareholderList2: '公司股东证书',
		companyConsentAdditionalInfoDescription:
			'您可以上传您目前手边的文件；只需提供地址和身份证明。 所有其他文件都可以稍后上传或通过电子邮件发送。',
		applicationFormConsentCheck:
			'我同意让 Tradeview Financial Markets S.A.C. 通过提供我的个人信息（包括身份证件）以电子方式验证我的身份。 该信息将与受信任的身份验证服务提供商共享，以确认其准确性并将其与他们持有或从其他可靠来源获取的数据进行匹配。',

		//Account holder details
		accountHolderDetailsTitle: '账户持有人信息',
		accountHolderDetailsTooltip:
			'账户持有人是管理公司账户的主要负责人。 此人执行交易、做出账户决策，并有权添加或删除股东。 确保账户持有人详细信息准确代表您公司活动的关键决策者。',

		//Account holder address
		accountHolderAddressTitle: '账户持有人地址',
		accountHolderAddressTooltip:
			'提供帐户持有人（管理公司帐户的个人）的住宅或营业地址。 该信息适用于账户持有人，而非公司本身。',

		//Account holder tax residency declaration
		accountHolderTaxResidencyTooltip:
			'提供账户持有人（管理公司账户的个人）的税务居民信息。 该信息适用于账户持有人，而非公司本身。',
		accountHolderTaxResidencyModalDescription:
			'很抱歉，由于监管原因，我们无法提供服务总部位于美国领土的公司或居住者。 感谢您有兴趣加入 Tradeview。',

		//Account holder trading experience
		accountHolderTradingExperienceDescription:
			'选择最能代表您个人交易外汇、股票、期货、衍生品或差价合约经验的选项。',

		//Shareholder consent
		shareholderConsentTitle: '恭喜您！ 帐户持有人申请现已完成。 ',
		shareholderConsentDescription1:
			'我们快完成了，我们只需要输入股东信息即可。',
		shareholderConsentDescription2:
			'如果需要，您可以使用屏幕右侧的进度列表随时编辑之前提供的详细信息。 只需单击您要编辑的信息旁边的铅笔图标即可。',
		shareholderConsentDescription3:
			'请记住，除了政府签发的带照片的身份证件和居住证明文件外，您可以在方便时上传必要的文件——现在或稍后根据要求上传。',
		companyConsentConsentDocumentsTitle:
			'在开始之前，请确保您或股东已准备好以下必备文件：',
		companyConsentConsentDescription1:
			'我们快完成了！只需输入股东的信息以完成过程。',
		companyConsentConsentDescription2:
			'如果需要，您可以通过点击右侧栏中的铅笔图标编辑您之前输入的任何详细信息。',
		shareholderConsentDocumentsTitle: '在开始之前，每个股东应准备以下文件：',
		shareholderConsentDocumentsList1: '股东政府签发的带照片的身份证件',
		shareholderConsentDocumentsList2: '股东居住证明',
		shareholderConsentDocumentsList3: '数字签名',
		shareholderConsentCheck:
			'我同意让 Tradeview Financial Markets S.A.C. 通过提供我的个人信息（包括身份证件）以电子方式验证我的身份。 该信息将与受信任的身份验证服务提供商共享，以确认其准确性并将其与他们持有或从其他可靠来源获取的数据进行匹配。',

		//Application Submition
		applicationSubmitionTitle: '提交申请表',
		applicationSubmitionDescription1: ' 我们感谢您为完成申请所做的努力。',

		applicationSubmitedTitle: '提交的公司申请：审核进行中',
		applicationSubmitedDescription1:
			'感谢您提交公司账户申请。 您的请求目前正在接受审核，很快就会得到验证。',
		applicationSubmitedDescription2:
			'如果您在填写信息期间选择不上传任何所需文件，我们的运营团队将与您联系。',
		//Global
		selectOption: '选择一个选项',
		accountOwnershipTooltip:
			'这是指您的业务主要所在的国家/地区。准确的信息有助于我们根据地区要求和法规定制我们的服务。如果选项中未列出您所在的国家/地区，我们很遗憾地通知您，我们无法在您所在的位置提供服务。',

		//Progress
		companyInformation: '公司信息',
		companyAddressDetails: '公司地址',
		companyOwnershipDetails: '公司所有权详情',
		companyDocuments: '公司文件',
		accountConsent: '账户授权',
		accountConsentCorporate: '账户持有人信息',
		tradingExperience: '交易经验',
		accountInformation: '账户信息',
		tradingExperience: '交易经验',
		IDVerification: '身份验证',
		accSetupSubmision: '账户设置与提交',
		shareholderInformation: '股东信息',
		shareholderConsent: '股东授权',
		finish: '完成',
		addressDetails: '地址详情',

		share: '分享',

		//Shareholder consent
		welcomeShareholderConsentTitle:
			'准备好加入您的公司账户了吗？让我们开始您的申请。',
		welcomeShareholderConsentDescription1:
			'为了设置您的公司帐户，请准备以下信息',
		shareholderConsentDocumentsTitle: '在开始之前，请准备以下文件：',
		welcomeShareholderConsentDocumentsList1: '政府颁发的带照片的身份证件',
		welcomeShareholderConsentDocumentsList2: '居住证明',
	},

	//disclaimer
	disclaimer: {
		secure1: ' 安全的',
		secure2: 'SSL 加密',
		secure3: '',
		term: '条款和条件',
		privacy: '隐私政策',
		aml: '反洗钱政策',
		withdrawal: '提款政策',
		refund: '退款政策',
		risk: '风险披',
		title: '免责声明',
		default: {
			description:
				'Tradeview Markets 提供的服务和产品不在美国境内提供，也不向美国法律定义的美国人士提供。本网站上的信息不针对任何当地法律或法规限制或禁止外汇和/或 CFD 交易的国家/地区的居民。',
		},
		ltd: {
			description:
				'Tradeview Ltd. 提供的服务和产品不在美国境内提供，也不向美国法律定义的美国人士提供。本网站上的信息不针对任何当地法律或法规限制或禁止外汇和/或差价合约交易的国家的居民。差价合约是复杂的工具，由于杠杆作用，存在快速亏损的高风险。在交易差价合约时，74% - 89% 的散户投资者账户亏损。您应该考虑您是否了解差价合约的运作方式，以及您是否有能力承担亏损的高风险。',
		},
		latam: {
			description:
				'Tradeview Financial Markets S.A.C. 提供的服务和产品不在美国境内提供，也不向美国法律定义的美国人士提供。本网站上的信息不针对任何当地法律或法规限制或禁止外汇和/或差价合约交易的国家/地区的居民。差价合约是复杂的工具，由于杠杆作用，存在快速亏损的高风险。74% - 89% 的散户投资者账户在交易差价合约时亏损。您应该考虑自己是否了解差价合约的运作方式，以及是否能够承担亏损的高风险。',
		},
		mena: {
			description:
				'Tradeview Financial Markets S.A.C. 提供的服务和产品不在美国境内提供，也不向美国法律定义的美国人士提供。本网站上的信息不针对任何当地法律或法规限制或禁止外汇和/或差价合约交易的国家/地区的居民。差价合约是复杂的工具，由于杠杆作用，存在快速亏损的高风险。74% - 89% 的散户投资者账户在交易差价合约时亏损。您应该考虑自己是否了解差价合约的运作方式，以及是否能够承担亏损的高风险。',
		},
	},

	//modal
	modal: {
		error: '你不能继续你的申请',
		description:
			'我们很抱歉。由于监管规定，我们无法为居住在美国境内的人们提供服务。',
		thank: '感谢您有兴趣加入 Tradeview。',
		btnRegulation: '访问监管页面',
	},

	//tooltips
	tooltips: {
		signature1:
			'选择您想要上传签名的方式。 您可以使用我们的签名上传功能，也可以使用我们的交互式工具直接绘制签名。 在下面选择您首选的方法。',
		sourceAccount: '提款账户',
		sourceAccountTransfer: '资金将从中转出的账户。',
		currencyUSD: 'USD：美元',
		currencyEUR: 'EUR: 欧元',
		currencyJYP: 'JPY: 日本日元',
		currencyCAD: 'CAD: 加拿大元',
		currencyGBP: 'GBP: 英镑',
		targetAccount: '将接收转账资金的账户。',
		digitalWallets:
			'为了您的方便，我们提供多种电子钱包选项。 请注意，费用可能会根据您选择的资金来源而有所不同。',
		wireTransfers:
			'使用这种存款方式，您需要选择您的银行，提供所需的信息，启动转账，您的资金将在平台验证后入账。',
		cardTransfers:
			'我们接受 Visa、Mastercard 和 Apple Pay 作为您的信用卡存款。 ',
		currencyUphold: `您的账户交易结算的主要货币。它使用以下缩写表示：<br/>USD：美元 <br/>EUR：欧元 <br/>GBP：英镑`,
		currencyType: '货币是您在帐户中使用的主要付款方式。',
		leverageTM:
			'杠杆使您能够控制比初始资本允许的更大的头寸，通常以 50:1 或 100:1 等比率表示，显示与您自己的存款相比您可以控制的股票。',
		demoXleverage: 'X-Leverage: 1:400',
		demoILC: 'ILC: 1:200',
		demoStock: 'Stock: 1:1',
		notSureAccount: '不确定选择哪种账户类型？您可以查看它们的详细信息。',
		ltd: {
			withdrawCurrency:
				'您的账户交易结算的主要货币。它使用以下缩写表示： <br><br> USD：美元 <br> EUR：欧元 <br> GBP：英镑',
		},
		latam: {
			withdrawCurrency:
				'货币是指您的账户交易结算的主要货币。它使用以下缩写表示',
		},
	},

	//register
	register: {
		goBack: '返回',
		titleRegister: '账户注册',
		AccountDesc:
			'欢迎来到我们的交易门户！选择模拟账户或真实账户，开启您的交易之旅，体验 Tradeview 的不同。',
		AccountChoose: '您想创建哪种类型的账户？',
		dinamicDescLive: '还没准备好开设真实账户？<spam>创建一个模拟账户。</spam>',
		dinamicDescDemo: '想要进行真实交易？<spam>创建一个真实账户</spam>',
		getYour: '立即开始交易！',
		or: '或者在这里注册：',
		email: '电子邮件',
		secure: '创建密码',
		confirmPassword: '确认密码',
		disclaimer:
			'免责声明：在开立账户之前，Tradeview Financial Markets S.A.C. (“Tradeview”) 有义务确保您或代表您进行交易的指定人员具备 CFD 和相关金融工具的必要知识和经验。我们还要求您遵守反洗钱和反恐怖融资义务。在这方面，请您按照本申请的要求提供准确、完整和真实的信息，以便我们完全履行上述义务。根据这些信息，我们能够正确确定与金融工具相关的投资服务是否适合您。所有部分都需要填写。有关更多详细信息，请参阅我们的客户协议。.',
		byTicking: '选中此框即表示您同意上述免责声明。',
		getstarted: '继续',
		messageFooter1: '由提供的服务和产品',
		messageFooter2:
			'提供的服务和产品不适用于美国（US），也不提供给根据美国法律定义的美国人士。此网站上的信息不针对任何国家的居民，这些国家对外汇（FX）和/或差价合约（CFD）交易有本地法律或法规限制或禁止。差价合约是复杂的工具，由于杠杆效应，存在快速亏损的高风险。74% - 89%的零售投资者账户在交易差价合约时会亏损。您应考虑是否理解差价合约的运作方式以及您是否能够承受高风险以避免资金亏损。74-89%的零售差价合约账户亏损。有关我们的费用的更多信息，请参阅此链接。.',
		client: '客户中心',
		instructionstitle1: '这是满足您所有交易需求的平台',
		instructionstitle2: '为您争分夺秒！',
		instructionstitle3: '',
		options1f: '受监管且安全',
		options1l: '',
		options2f: '个性化协助',
		options2l: '',
		options3f: '无与伦比的流动性',
		options3l: '',
		haveAccount: '请登录您的账号',
		signUp: ' 登录',
		newCode: '一次性验证码已发送到',
		tryEgain: '我们现在无法重新发送您的代码。请重试。',
		invalidEmail: '无效的格式，请再试一次。',
		passwordRequired: '必填项，请填写',
		invalidPassword:
			'密码须包含至少 8 个字符，其中至少包括1个小写字母、1个大写字母、1个数字和1个特殊字符。',
		confirmPasswordRequired: '必填项，请填写',
		passwordsDoNotMatch: '密码不匹配。请重试',
		errorDisclaimer: '请选中确认复选框以继续',
		firstNameError: '必填项，请填写',
		typeAccountError: '请选择帐户类型',
		invalidName: '您的名字不能包含数字或符号。请再试一次。',
		invalidLastName: '您的姓氏不能包含数字或符号。请重试。.',
		mfaCode: '输入 MFA 代码e',
		startDemo: '立即获取您的免费模拟帐户！',
		orRegister: '或者在这里注册：',
		verificationCode: '验证码',
		didntCode: '没有收到验证码',
		yourEmail: '你的邮箱地址',
		firstName: '名',
		lastName: '姓',
		accountType: '帐户类型',
		accountCategory: '帐户类型',
		accountCategoryPlaceholder: '选择账户类别',
		accountCategoryTooltip: `<strong>个人账户:</strong>  </br> 如果您是单个账户持有人，请选择此选项。 </br></br> <strong>联名账户</strong>  </br> 如果您与其他人（例如配偶或商业伙伴）一起开立账户，请选择此选项。 </br></br> <strong>公司账户：</strong> </br> 如果您代表某个实体、企业或组织，请选择此选项。 `,
		entity: '实体:',
		entityPLaceholder: '选择一个实体',
		entityTooltip:
			'我们在所有经营所在地都遵守严格的财务标准。请在此处了解更多信息。',
		countryTooltip:
			'如果您的居住国家不在选项中，很遗憾我们无法在您的位置提供服务。',
		checkRegis:
			'通过选中此框，我承认 Tradeview 或与 Tradeview 相关的任何个人没有要求我更换实体。',
		changeRegion: '更改为我所在地区的实体',
		liveIndividual: '个人真实账户 </br> 立即开始交易！',
		jointIndividual: '联合真实账户 </br> 立即开始交易！',
		corporateIndividual: '企业真实账户 </br> 立即开始交易！',
		entityText:
			'您即将为您的账户创建选择一个在您选择的居住国家以外的地区建立并受监管的实体。',
		entity: '实体:',
		entityPLaceholder: '选择一个实体',
		entityTooltip:
			'我们在所有经营所在地都遵守严格的财务标准。请在此处了解更多信息。',
		accountRegis: '重要提醒',
		entityTextEu: `您现在访问的网站由 Tradeview Ltd. 运营，该实体未在欧盟设立，也不受欧盟国家主管当局监管。  <br><br> 点击“继续”，即表示您确认 Tradeview 或与 Tradeview 相关的任何个人均未要求您切换实体。<br><br> 要转到受欧盟监管的实体 Tradeview Europe Ltd.，请点击“更改为我所在地区的实体”。Tradeview Europe Ltd. 受 MFSA 监管，适用于您的司法管辖区。`,
		entitiesTitle: '国际实体以我们的品牌进行交易：',
		entitiesDesc: `<ul> <li> <b>Tradeview Ltd. (开曼群岛)</b> </li> </ul> <p>由开曼群岛货币管理局 (CIMA) 监管，依照开曼群岛法律 (SIBL) 运作。</p> <br> <ul> <li> <b>Tradeview Financial Markets S.A.C (秘鲁)</b> </li> </ul> <p>在 SUNARP 注册，依照秘鲁《公司通用法》（LGS）运作。</p>`,
		entitiesDescEu: `<ul> <li> <b>Tradeview Ltd. (开曼群岛)</b> </li> </ul> <p>由开曼群岛货币管理局 (CIMA) 监管，依照开曼群岛法律 (SIBL) 运作。</p> <br> <ul> <li> <b>Tradeview Financial Markets S.A.C (秘鲁、日本、中东和北非)</b> </li> </ul> <p>在 SUNARP 注册，依照秘鲁《公司通用法》（LGS）运作。</p>`,
		individual: '个人',
		joint: ' 联合账户',
		corporate: '公司账户',
		individualIB: '個人 IB 帳戶',
		reloadPage: '请刷新页面以继续。这将修复阻止数据输入的问题。',
		instructionsIB1: '发展您的代理商业务——只需不到 5 分钟即可成为代理！',
		instructionsIB2: '',
		instructionsIB3: '',
		titleIbRegister: 'Tradeview Markets 新用户？',
		disclaimerIBportal:
			"免责声明：在开立账户之前，Tradeview Financial Markets S.A.C. ('Tradeview') 有义务确保您或代表您进行交易的指定人员具备 CFD 和相关金融工具的必要知识和经验。我们还要求您遵守反洗钱和反恐怖融资义务。在这方面，请您按照本申请的要求提供准确、完整和真实的信息，以便我们完全履行上述义务。根据这些信息，我们能够正确确定与金融工具相关的投资服务是否适合您。所有部分都需要填写。有关更多详细信息，请参阅我们的客户协议。",
		alreadyClient: '已经是 Tradeview 客户？登录您的客户后台也可注册成为代理。',
		loginClientCabinet: '',
		registerIB: '',
		instructionsIBportal1: '我們為您提供服務！',
		instructionsIBportal2: '解決方案',
		instructionsIBportal3: '需求',
		options1f_ib_portal: '交鑰匙客戶',
		options1l_ib_portal: '解決方案',
		options2f_ib_portal: '客戶支援',
		options2l_ib_portal: '24/5 可用',
		options3f_ib_portal: '每日支付回扣',
		options3l_ib_portal: '和佣金',
		register_enjoy: '立即注册并享受以下优势:',
		fast_onboarding: '快速入驻流程',
		no_program: '无需预付费用的计划',
		fast_solutions: '一站式客户解决方案',
	},

	'reset-password': {
		instructionstitle1: '这是满足您所有交易需求的平台',
		instructionstitle2: '为您争分夺秒！',
		instructionstitle3: '',
		title: '设置新密码',
		label1: '新密码',
		label2: '确认密码',
		options1f: '受监管且安全',
		options1l: '',
		options2f: '个性化协助',
		options2l: '',
		options3f: '无与伦比的流动性',
		options3l: '',
	},

	//Calendar
	calendar: {
		title: '日历',
	},

	//application process
	application: {
		optional: '(オプション)',
		ifApplicable: '(如果适用)',
		jobTitleL: '职位名称',
		jobTitleP: '请输入您的职位名称',
		emplymentAditionalDetails: '附加信息',
		optional: '（选修的）',
		taxResTitle: '您的税务居民身份声明',
		taxResPurposes: '您是美国公民还是美国税务居民？',
		taxLabelCompany: '公司特此确认，在税务目的上，其为以下国家的税务居民:',
		taxLabelIndividual: '本人特此确认，在税务目的上，本人为以下国家的税务居民:',
		taxResHereby: '我特此确认，出于税务目的，我是以下国家/地区的居民：',
		taxResCountryL: '国家',
		taxResCountryP: '选择一个国家',
		taxResMarketL: '税务参考代码',
		jobTitleL: '职位名称',
		jobTitleP: '输入您的职位名称',
		taxResMarketP: '输入您的税务参考代码',
		taxResMarketTM:
			'您的税务参考代码可能由字母和数字组合而成，也可能完全由数字组成。请放心，您的信息在我们这里是安全的。根据经合组织的报告标准，我们有义务要求提供此信息。您可以在此处了解更多信息。',
		taxResPoliticalL: '您是政治公众人物 (PEP)、政治公众人物的近亲或关联人吗？',
		taxResPoliticalTM:
			'PEP（政治公众人物）是指担任或曾经担任过重要公共职务的人，对金融风险评估具有潜在影响。',
		taxResStatusL:
			'您的政治公众人物身份是什么，或者您与政治公众人物有什么关系？',
		taxResStatusP: '请向我们提供您的 PEP 状态或关系的详细信息。',
		taxResStatusTM:
			'您需要披露您的 PEP 状态或任何相关关系，以便为双方（您和 Tradeview）充分了解风险。 尽管如此，请放心，如果您是政治公众人物或与政治公众人物有任何关联，我们仍然欢迎您继续进行申请流程。',
		taxCode: '税务参考代码',
		taxCodeTooltip: `您的税务参考代码可能由字母和数字的组合组成，也可能是纯数字。您的信息对我们是安全的。根据 OECD 报告标准，我们需要收集这些信息。您可以在 <a href="https://www.oecd.org/tax/automatic-exchange/common-reporting-standard/" target="_blank" rel="noopener noreferrer">这里</a> 了解更多信息。`,
		selectTaxCode: '输入您的税务参考代码',
		accountTypeH: '您的账户类型',
		accountTypeD:
			'创建您的第一个 Tradeview 账户后，您可以轻松地为不同的金融资产开设更多账户，而无需再次填写整个表格。',
		tradingMarketL: '交易产品',
		tradingMarketP: '选择市场',
		tradingMarketTM:
			'交易市场是资产或工具上市或报价进行交易的市场或交易所。不确定选择哪个市场？ 您可以在这里查看市场信息',
		currencyTypeL: '货币类型',
		currencyTypeP: '选择货币类型',
		currencyTypeTM:
			'货币是您在帐户中使用的主要付款方式。它使用以下缩写表示： <br><br> 美元：美元 <br> 欧元：欧元 <br> 日元：日元 <br> CAD：加拿大元”',
		platformL: '平台',
		platformP: '选择平台',
		platformTM:
			'交易平台是用于操作资产或工具的软件系统。不确定选择哪个平台？ 您可以在这里查看',
		accountTypeL: '帐户类型',
		accountTypeP: '选择账户类型',
		accountTypeTM:
			'账户类型允许您选择您的账户可以获得的杠杆<br><br> 标准账户：1:400<br> ECN账户：1：200<br> 美股账户：1:1 <br><br> 不确定选择哪种帐户类型？ 您可以在这里查看',
		emplymentDetailsH: '详细就业信息',
		employmentStatusL: '就业状况',
		employmentStatusP: '选择状态',
		employerL: '雇主',
		employerP: '输入您的雇主姓名',
		occupationL: '职业',
		occupationP: '请输入您的职业',
		industryL: '行业',
		industryP: '选择您的业务性质',
		industryTM: "'行业描述了您所雇用的公司的基本特征和活动。'",
		employmentTypeL: '雇佣类型',
		employmentTypeP: '选择就业性质',
		employmentTypeTM:
			'雇佣类型描述了定义您的工作安排或工作状态的基本特征和条件',
		employmentAddressL: '雇主地址',
		employmentAddressP: '输入您的工作地址',
		employerCountryL: '雇主所在国',
		employerCountryP: '选择一个国家',
		employerProvinceL: '雇主省份',
		employerProvinceP: '选择省份',
		employerCityL: '雇主所在城市',
		employerCityP: '选择城市',
		employerZipL: '雇主邮政编码',
		employerZipP: '输入您雇主的邮政编码',
		businessTypeL: '业务类型',
		businessTypeP: '选择业务类型',
		businessTypeTM:
			'商业类型是指组织或企业在商业世界中经营时可以采取的各种法律结构和形式。',
		businessCountryL: '商业国家',
		businessCountryP: '选择一个国家',
		businessProvinceL: '业务省份',
		businessProvinceP: '选择省份',
		businessCityL: '商业城',
		businessCityP: '选择城市',
		businessLocationL: '营业地点',
		businessLocationP: '输入您的公司地址',
		businessNameL: '企业名称',
		businessNameP: '输入您的公司名称',
		businessWebL: '企业网站',
		businessWebP: '输入您的企业网站网址',
		businessIndustryL: '行业',
		businessIndustryP: '选择您的业务性质',
		businessIndustryTM: "'行业描述了您所雇用的公司的基本特征和活动。'",
		financialDetailsH: '您的财务详细信息',
		annualIncomeL: '您的年收入/总营业额是多少？',
		totalAssetsL: '您的总资产余额是多少？',
		totalAssetsTM: '您的资产余额是扣除承诺后的储蓄、投资、房地产的价值。',
		liquidAssetsL: '您的流动资产余额是多少？',
		liquidAssetsTM:
			'您的流动资产余额是您的现金、货币、市场工具和有价证券的总和。',
		tradeAnnuallyL: '您计划每年投资/交易多少？',
		originAssetsL: '你的总资产的来源是什么？',
		originDepositsL: '您的存款/资金的来源/来源是什么？',
		purposeAccountL: '该帐户的目的是什么？',
		bankruptciesDetailsL: '破产详情',
		bankruptciesDetailsP: '添加与您相关的破产的信息',
		bankruptciesDetailsTM:
			' 您需要披露任何破产关系，以了解双方（您和 Tradeview）的风险。<br><br> 尽管如此，请放心，如果您涉及任何破产，我们仍然欢迎您继续进行申请程序。',
		bankruptciesConnetL: '你与破产有关吗？',
		tradingExperienceH: '您的交易经验',
		tradingExperienceD:
			'选择最能代表您的外汇、股票、期货、衍生品或差价合约交易经验的选项。',
		tradingExperienceDMENA:
			'请选择最能代表您在外汇、股票、衍生品或差价合约交易经验的选项。',
		tradingExperienceTM:
			'我们询问您的交易经验，以帮助我们提供个性化的支持、指导和最佳的交易体验，无论您是经验丰富的交易者还是新手。',
		yearsTradingL: '您从事交易多少年了？',
		yearsTradingP: '选择一个选项',
		tradingVolumenL: '您的交易量是多少？',
		tradingVolumenP: '选择一个选项',
		oftenTradeL: '您多久进行一次交易？',
		oftenTradeP: '选择一个选项',
		identityH: '您的身份验证',
		identityDesc: '要完成验证，您需要以下其中一份文件：',
		identityD:
			'此步骤是必需的。为了获得更流畅的体验，我们建议您在移动设备上使用下面的二维码完成此步骤。',
		identityDLatam:
			'为了更顺畅的体验，我们建议您使用下面的二维码在手机上完成此步骤。您需要以下文件之一进行验证：',
		idDocumentL: '身份证件',
		idDocumentP: '选择文件类型',
		idDocumentTM:
			'证件类型指的是您可以用来确认身份以确保交易安全的身份证件类型。我们接受以下证件：  <br><br>护照（建议）<br>身份证<br>居留许可<br>驾驶执照',
		idDocumentUploadL: '文件上传 ',
		idDocumentUploadTM: '请确保文件中的信息和图像清晰易读。',
		idDocumentFrontL: '正面',
		idDocumentFrontTM: '您的身份证正面显示您的照片、全名和身份证号码。',
		idDocumentBackL: '背面',
		idDocumentBackTM: '您的身份证背面包含其他信息，如您的地址和其他相关细节。',
		proofResidenceH: '您的居住证明',
		proofResidenceHYour: '您的居住证明',
		proofResidenceD: '确认您的位置以确保符合监管标准。',
		proofResidenceL: '居住证明文件',
		proofResidenceP: '选择文档类型',
		proofResidenceTM:
			'要验证您的地址，请提供以下文件之一： <br><br>  • 水电费账单  <br>  • 银行对帐单<br> • 居住证明  <br><br>   接受的账单包括：  <br> • 气体    <br>• 电  <br>  • 水  <br>  • 固定电话  <br>  互联网（如果连接到住所） <br>  电缆（如果连接到住宅）  <br> • 银行或信用卡对账单（带有交易历史记录）<br><br>  我们不接受显示大额现金存款的手机账单或银行对账单',
		proofUploadL: '文件上传 ',
		proofUploadTM:
			'请确保文件： <br><br> • 不超过3个月 <br>• 包括你的名字 <br>• 拥有与您申请中的地址相符的地址 <br>• 不是截图 <br>• 没有被切断 <br>• 没有被阻止/屏蔽的信息 <br>• 有可翻译的语言',
		addressDetail: '地址',
		financialDetailsTM:
			'您需要披露您的财务详细信息，以便为双方（您和 Tradeview）了解风险。',
		acknowledgementH: '阅读文件',
		acknowledgementCheck:
			'通过选中此框，我承认我已阅读、理解并同意上述所列文件中包含的所有信息。',
		signatureH: '签名',
		signatureP1: '通过在下面签名，我承认并同意此流程上一步中列出的文件',
		signatureP2:
			'此外，我进一步承认并同意，申请中提供的所有信息均真实准确，并且无论来源、货币类型或存款方式如何，我账户中的所有存款都不是以下收益： 犯罪或非法活动且源自合法来源。',
		signatureMethod: '您想使用什么签名方法？',
		signatureDraw: '签名',
		signatureUpload: '上传签名',
		signatureTM:
			'选择您想要上传签名的方式。 您可以使用我们的签名上传功能，也可以使用我们的交互式工具直接绘制签名。 在下面选择您首选的方法。',
		signatureAD: '授权客户签名，在上面签名',
		additionalRiskH: '额外风险披露',
		additionalRiskD1:
			'您的账户申请中提供的信息表明，由于以下原因之一，您不符合 Tradeview Financial Markets S.A.C. 开立交易账户的准则：',
		additionalRiskP1Latam:
			' 除了 Tradeview Markets 客户账户协议中包含的行业标准披露外，您还应意识到外汇交易被视为一种高风险的投资。如果您过去只进行过保守的投资，建议您在继续这种类型的投资之前深入了解外汇交易。',
		additionalRiskP2Latam:
			'如果您希望继续投资，您承认您承诺的资金纯粹是风险资本，投资损失不会危及您的生活方式，也不会影响您未来的退休计划。此外，您完全理解外汇投资的性质和风险，若您遭受投资损失，您对他人的义务也不会被忽视。',
		additionalRiskUl1: '您的年龄不在 21 岁至 63 岁之间d',
		additionalRiskUl2: ' 您的年收入低于 25,000 美元',
		additionalRiskUl3: '您在过去一年内申请破产',
		additionalRiskUl4: '您没有工作',
		additionalRiskD2:
			'虽然 Tradeview Financial Markets S.A.C. 准备开设您的账户，但有必要建议您重新考虑这项投资。 根据您的个人信息和/或投资经验，外汇投资策略的风险可能太大。 外汇交易的损失可能是巨大的。 因此，您应该根据您的情况和财务资源仔细考虑此类交易是否适合您。 由于保证金要求较低，外汇交易中可获得的高杠杆可能对您不利，也可能对您有利。 使用杠杆可能会导致巨大的损失和收益。',
		additionalRiskChk1:
			'我了解我不符合 Tradeview Financial Markets S.A.C. 在上述段落中规定的开设账户的最低准则。 但是，我根据我的个人情况考虑了外汇交易涉及的财务风险，我希望继续开立账户。',
		additionalRiskChk2: '我确认我已阅读上述内容并完全理解此处提供的信息。',
		additionalRiskChk1Latam:
			'"我意识到与我的交易账户相关的固有风险，并考虑了失去投资的所有可能后果。在阅读了与外汇交易相关的风险后，我愿意继续进行开户流程。',
		additionalRiskChk2Latam: '我确认我已阅读上述内容并完全理解此处提供的信息。',
		submitApplicationH: '提交申请',
		submitApplicationD1: '我们感谢您完成申请流程。.',
		submitApplicationD2: ' 准备好后，只需单击下面的提交按钮即可发送。',
		submitApplicationD3: '如果您有任何疑问或需要帮助，',
		submitApplicationLink: '请随时与我们联系。',
		submitApplicationCheck: '我/我们同意加入我们的营销邮件名单',
		applicationSubmitedH: '已提交申请：审核中',
		applicationSubmitedD1:
			' 感谢您提交帐户申请。 您的请求目前正在接受审核，很快就会得到验证。',
		applicationSubmitedD2:
			'如果需要任何进一步的文件，我们的运营团队将与您联系。',
		applicationSubmitedD3: ' 我们感谢您的合作，并将随时向您通报最新进展情况。',
		applicationSubmitedGT: '访问客户后台',
		applicationSubmitedET: '浏览 Tradeview',
		apEmailL: '电子邮件',
		apFirstNL: '名',
		apFirstNP: '名',
		apLastNL: '姓',
		apLastNP: '姓',
		apDateBL: '出生日期',
		apCountryBL: '出生国家',
		apCountryBP: '选择一个国家',
		apCountryNL: '国籍',
		apCountryNP: '选择国籍',
		apMobileL: '手机（可选）',
		apPhoneL: '电话',
		apPassL: '身份证/护照号码/SIN',
		apPassP: '输入您的身份证件、护照或 SIN',
		apPassT:
			'您只需输入其中一份身份证明文件。 请记住，只有加拿大的用户才需要 SIN（社会保险号）。',
		apPassDL: '身份证/护照/SIN 有效期',
		apGenderL: '性别',
		apGenderP: '选择一个选项',
		apMaritalL: '婚姻状况',
		apMaritalP: '选择一个选项',
		apCountryRL: '所在国家',
		apCountry: '国家',
		apCountryRLTooltip: `这指的是您的业务主要所在的国家。准确的信息有助于我们根据地区要求和法规定制我们的服务。如果您的所在国家未列入选项中，很遗憾我们无法在您的位置提供服务。`,
		apCountryRLResidence: '居住国家',
		apCountryRP: '选择一个国家',
		apProvinceRL: '州/省',
		apProvinceRP: '选择省份',
		apCityRL: '城市',
		apCityRP: '选择城市',
		apStreethRL: '街道名称',
		apStreethRD: '输入您的街道名称',
		apStreethNL: '街牌号码',
		apStreethND: '输入您的街道号码',
		apPostCL: '邮政编码',
		apPostCD: '输入您的邮政编码',
		appAddresT:
			'如果您的居住国家/地区未在选项中列出，我们很遗憾地通知您，我们无法在您所在的地区提供服务',
		modalCompleteT: '所有信息已',
		modalCompleteT2: '完成！',
		modalCompleteP:
			'我们已获取完成过程所需的所有必要信息。最后一步是添加账户持有人的签名并提交申请。您的旅程即将完成！',
		modalRegulationT: '您无法继续进行',
		modalRegulationT2: '您的申请',
		modalRegulationP:
			'我们很抱歉。由于监管规定，我们无法为居住在美国境内的人们提供服务。',
		modalRegulationP2: '感谢您有兴趣加入 Tradeview。',
		signatureTM2:
			'请确保签名与您之前上传的文件中的签名一致。接受的文件格式为：jpg、jpeg 和 png，最大文件大小为 2MB。',
		submitModal:
			'我们在表单上检测到一些错误，请检查并重试，如果问题仍然存在，请联系我们的支持团队。',
		areaPH: '区域',
		phonePH: '请输入您的手机号码',
		emailPH: '输入你的电子邮箱',
		errorUpload: '请上传有效格式和大小的文件。',
		apBtnContinue: '继续',
		apBtnSubmit: '提交',
		apBtnBack: '后退',
		apBtnRegulation: '访问监管页面',
		complete: '完全的',
		pending: '待办的',
		rejected: 'Rejected',
		accepted: 'Accepted',
		enterFirstName: '输入名字',
		enterLastName: '输入姓氏',
		enterAnEmail: '输入电子邮件',
		sendInvitation: '发送邀请',
		pendingShareholderTitle: '股东信息缺失',
		pendingShareholderDesc:
			'您有未完成的股东信息。请填写每位股东所需的信息以继续操作。',
		invitationSent: '邀请已发送成功！',
		invitationSentDesc: '您可以在辅助持有人添加页面上跟踪申请进度。',
		modifiedInvitation: '第二账户持有者信息更新成功',
		modifiedInvitationDesc:
			'已向您提供的第二账户持有者的电子邮件地址发送了邀请。您可以在“第二账户持有者添加”页面跟踪申请进度。',
		notModifiedInvitation: '第二账户持有者信息更新成功',
		notModifiedInvitationDesc: '您可以在“第二账户持有者添加”页面跟踪申请进度。',
		resend: '重新发送邀请',
		saveShareholder: '保存股东',
		shareholderToComplete: '邀请股东完成',
		companyDocuments: '公司文件验证',
		companyDocumentsDesc:
			'验证您的帐户，确保合规性并根据您的业务需求定制我们的服务。',
		documentUpload: '文件上传',
		documentUploadTooltip1: '确保文件中的信息和图像清晰易懂。',
		documentUploadTooltip2:
			'请随意上传您目前拥有的文件。 如果有些内容丢失，请不要担心； 您可以稍后根据要求上传或发送',
		documentUploadDesc:
			'选择立即上传文档还是稍后保存。如果选择立即上传，您可以方便地拖放文件或浏览文件夹。',
		articlesIncorp: '公司章程',
		certificateIncorp: '公司注册证书',
		shareholderBreak: '股东明细',
		corporateBank: '公司银行对账单',
		memorandumArticles: '公司章程/章程细则',
		uploadNow: '现在上传？',
		imageType: '确保文件为JPEG、JPG或PNG格式且大小不超过3MB。.',
		sharesError: '股东和账户持有人的合计百分比不能超过100%。 请再试一次。',
		inviteConfirmation: '准备好发送所有邀请了吗？',
		inviteConfirmationDesc:
			'我们将邮件将发送给您添加到帐户的所有股东。 一旦发送，您将不会 能够增加更多股东。',
		inviteSent: '邀请已成功发送！',
		inviteSentDesc: '您可以在股东增补页面查询各股东的申请进度。',
		deleteHolder: '您确定要删除该股东吗？',
		deleteHolderDesc:
			'你即将删除其中一个与您的公司帐户关联的股东。你想继续吗？',
		unableToContinue: '无法继续',
		unableToContinueDesc:
			'您提供的电子邮件地址已与Tradeview账户关联。请提供另一个电子邮件地址以继续。',
		provideAnother: '请提供另一个电子邮件地址',
		duplicated: '重复',
		duplicatedDesc:
			'您输入的电子邮件已与Tradeview账户关联。请提供另一个电子邮件以继续。',
	},

	//validations yup app process
	yup: {
		selectOption: '请选择一个选项',
		phone: '您的电话号码不能包含字母或符号。',
		phoneValid: '请输入有效的电话号码',
		dateofBirth: '请输入你的生日',
		validEmail: '请输入有效的电子邮件',
		mustBeAdult: '请输入有效的出生日期。您必须年满18岁才能继续.',
		passport: '请输入您的身份证号码',
		passportValid: '请输入有效的电话号码',
		passportexpirationdate: '请输入一个有效的日期',
		passportexpirationdateValid: '请输入有效的到期日期。仅接受当前文件',
		streetname: '请输入您的街道名称',
		streetnumber: '请输入您的街道号码',
		postcode: '请输入您的邮政编码',
		taxReference: '您的税务参考代码不能包含空格或符号。请重试',
		pepstatus: '请输入所需信息',
		pepstatusValid: '超过字符限制',
		employer: '请输入您的雇主姓名',
		occupation: '请输入您的职业',
		employerAddress: '请输入您的雇主地址',
		employerpostalcode: '请输入您雇主的邮政编码',
		businesstype: '请输入您的业务类型',
		industry: '请输入您的经营行业',
		business_location: '请输入您的公司地址',
		business_name: ' 请输入您的公司名称',
		business_website: ' 请输入您的企业网站网址',
		bankruptciesdetails: '请写下您的破产关系详细信息。',
		acknowledgement: '请选中确认复选框以继续',
		agree: '请选中确认复选框以继续',
		expirationDate: '护照有效期无效',
		invalidEmail: '电子邮件格式无效',
		EmailRequired: '电子邮件是必需的',
		companyName: '请输入母公司的名称。',
		email: '请输入公司电子邮件',
		businessDescription: '请输入所要求的信息。',
		required: '必填项，请填写',
		jobTitle: '请输入您的职位名称',
		emailAlreadyRegistered: '输入的电子邮件已被注册。请使用不同的电子邮件。',
	},

	//helper arrays app proces
	array: {
		usd: '美元',
		eur: '欧元',
		gbp: '英镑',
		female: '女性',
		male: '男性',
		noBinary: '跨性别',
		other: '其他',
		noAnswer: '我宁愿不回答',
		single: '单身的',
		married: '已婚',
		divorced: '离婚',
		windowed: '丧偶',
		registered: '同居',
		yes: '是的',
		no: '不',
		employed: '就业',
		selfEmployed: '自雇',
		retired: '退休',
		unemployed: '失业',
		aerospaceAndDefense: '航空航天和国防',
		agriculture: '农业',
		automotive: '汽车',
		construction: '建造',
		consulting: '咨询',
		eCommerce: '电子商务',
		education: '教育',
		energyAndUtilities: '能源和公用事业',
		entertainmentAndMedia: '娱乐和媒体',
		fashionAndApparel: '时尚服饰',
		financeAndBanking: '金融与银行',
		foodAndBeverage: '食品与饮品',
		government: '政府',
		healthAndWellness: '健康与保健',
		hospitality: '款待',
		itTechnology: '信息技术/技术',
		legalServices: '法律服务',
		manufacturing: '制造业',
		marketingAndAdvertising: '市场营销和广告',
		nonProfitCharity: '非营利/慈善机构',
		realEstate: '房地产',
		retail: '零售',
		benefitCorporation: '公益企业',
		cooperative: '合伙企业',
		cooperativeCorporation: '合作法人',
		corporation: '公司',
		familyOwnedBusiness: '家族企业',
		franchise: '特许经营',
		holdingCompany: '控股公司',
		jointVenture: '合资企业',
		llc: '有限责任公司（LLC）',
		lllp: '有限责任有限合伙企业 (LLLP)',
		llp: '有限责任合伙企业 (LLP)',
		lp: '有限合伙企业（LP）',
		nonprofitOrganization: '非盈利机构',
		合伙: '合伙',
		privateEquityFirm: '私募股权公司',
		professionalCorporation: '专业公司（PC）',
		publiclyTradedCompany: '上市公司',
		sCorporation: 'S公司',
		socialEnterprise: '社会企业',
		soleProprietorship: '独资企业',
		serviceProvider: '服务提供者',
		telecommunications: '电信',
		transportationAndLogistics: '运输与物流',
		apprenticeship: '学徒制',
		casual: '休闲',
		contractual: '合同性的',
		freelance: '自由职业者',
		fullTime: '全职',
		internship: '实习',
		onDemand: '一经请求',
		outsourcedOrOffshore: '外包或离岸',
		partTime: '兼职',
		permanent: '兼职',
		projectBased: '基于项目',
		regular: '常规的',
		seasonal: '季节性',
		temporary: '暂时的',
		volunteer: '志愿者',
		benefitCorporation: '公益企业',
		cooperative: '合伙企业',
		cooperativeCorporation: '合作法人',
		corporation: '公司',
		familyOwnedBusiness: '家族企业',
		franchise: '特许经营',
		holdingCompany: '控股公司',
		jointVenture: '合资企业',
		limitedLiabilityCompany: '有限责任公司（LLC）',
		limitedLiabilityLimited合伙: '有限责任有限合伙企业 (LLLP)',
		limitedLiability合伙: '有限责任合伙企业 (LLP)',
		limited合伙: '有限合伙企业（LP）',
		nonprofitOrganization: '非盈利机构',
		合伙: '合伙',
		privateEquityFirm: '私募股权公司',
		professionalCorporation: '专业公司（PC）',
		publiclyTradedCompany: '上市公司',
		sCorporation: 'S公司',
		socialEnterprise: '社会企业',
		soleProprietorship: '独资企业',
		below25: '低于 25,000 美元',
		between50: '25,000 美元 - 50,000 美元之间',
		between100: '50,000 美元 - 100,000 美元之间',
		over100: '超过 100,000 美元',

		// CORPORATE
		below50mil: '少于 50,000 美元',
		between100mil: '50,000 美元 - 100,000 美元之间',
		between500mil: '100,000 美元 - 500,000 美元之间',
		between1000mill: '介于 $500,000 美元至 $1,000,000 美元之间',
		over1000mill: '超过 $1,000,000 美元',
		// END CORPORATE

		savingsFromSalary: '存款',
		governmentAid: '政府援助',
		sale: '销售',
		investmentsDividends: '投资、股息',
		incomeFromATrust: '来自信托的收入',
		letting: '出租',
		inheritance: '遗产',
		donation: '捐款',
		loan: '贷款',
		incomeFromSelfEmployment: '自营职业收入',
		parentsPartnerOrOther: '父母、伴侣或其他',
		relativeSupport: '相对支持',
		hedging: '对冲',
		speculation: '投机',
		longTermInvesting: '长期投资',
		proprietaryTrading: '自营交易',
		drawSignature: '签名',
		uploadSignature: '上传签名',
		neverTraded: '我从来没有交易过',
		zeroToFiveYears: '0-5年',
		sixToTenYears: '6-10年',
		overTenYears: '超过10年',
		below50K: '低于 50,000 美元',
		between50KTo100K: '50,000 美元 - 100,000 美元之间',
		between100KTo500K: '100,000 美元 - 500,000 美元之间',
		over500K: '超过 500,000 美元',
		daily: '每日',
		weekly: '每周',
		monthly: '每月',
		quarterly: '季刊',
		semiAnnually: '每半年一次',
		clientAgreement: '客户协议',
		electronicTradingAgreement: '电子交易协议',
		riskDisclosure: '风险披露',
		privacyPolicy: '隐私政策',
		consentToDelivery: '同意通过电子媒体发送报表',
		commissionAgreement: '佣金协议',
		termsAndConditions: '条款和条件',
		swapFreeAccount: '无掉期确认书',
		swapFree: '免掉期账户申请表',
		forex: '外汇',
		stocks: '股票',
		futures: '期货',
		months: {
			january: '一月',
			february: '二月',
			march: '行进',
			april: '四月',
			may: '五月',
			june: '六月',
			july: '七月',
			august: '八月',
			september: '九月',
			october: '十月',
			november: '十一月',
			december: '十二月',
		},
		passport: '护照',
		identityCard: '身份证',
		residencePermit: '居留许可',
		driversLicense: '驾照',
		utilityBill: '水电费账单',
		bankStatement: '银行对账单',
		certificateResidency: '居住证明',
		today: '今天',
		lastWeek: '上星期',
		lastMonth: '上个月',
		last3Months: '过去 3 个月',
		last6Months: '过去 6 个月',
		costumPeriod: '自定义区间',
		lastQuarter: '上季度',
		lastSemester: '上学期',
		lastYear: '去年',
		step: '步骤',
		sell: '卖',
		buy: '买',
		transfer: '转账',
		deposit: '存款',
		withdrawal: '取款',
		payout: '支付',
		adjustment: '调整',
		live: '真实',
		demo: '模拟',
	},
	//MFA
	mfa: {
		body: '除了密码之外，请设置辅助验证方法，以使您的帐户更加安全。',
		text: '启用两步验证后，您需要输入密码以及发送到您电子邮件地址的验证码。',
		turn: '打开',
		on: '',
		off: '关闭',
		confirm: '确认',
		textTwo: '您确定要禁用 MFA 吗？',
		yes: '是的',
		no: '不',
	},

	progress: {
		title: '申请进度',
		progress1: '个人资料',
		progress2: '税务居民身份',
		progress3: '平台和货币',
		progress31: '账户设置',
		progress4: '就业详情',
		progress5: '财务细节',
		progress6: '经验',
		progress7: '身份证类型',
		progress8: '居住证明',
		progress9: '阅读文件',
		progress91: '同意并提交',
		progress10: '签名',
		progress11: '额外风险披露',
		progress12: '提交申请',
		progress121: '提交',
		progress13: '第二账户持有人',
		progress131: '添加账户持有人',
	},

	btns_: {
		back: '后退',
		continue: '继续',
		cancel: '取消',
		yesDelete: '是的，删除',
		noDelete: '不，返回',
		resendInvitations: '重新发送邀请s',
		of: 'of',
		yesImSure: '是，我确定',
		submit: '提交',
	},

	trading_tools: {
		main_title: '您的交易工具',
		main_desc:
			'通过使用我们的强大交易工具，做出更智能、基于数据的决策，帮助您在市场中获得优势。',
		calculatorSuite: '计算器套件',
		calculatorSuiteDesc:
			'为战略交易准备所有必备工具！这个强大的工具包旨在赋能您并挖掘您的潜力，无论您的交易水平如何。',
		tradegatehub: 'TradeGATEHub',
		tradegatehubDesc:
			'访问免费的成长资源，如与交易员和专家的实时聊天、直播以及实时市场新闻，帮助您自信地掌控市场。',
		surfsup: 'Surf’s Up!',
		surfsupDesc: '随时了解最新的市场动态，并探索新的策略、见解和分析。',
	},

	authErrors: {
		default: '发生了意外错误。请稍后再试。',

		register: {
			usernameExists: '此电子邮件已被注册。请登录或使用其他电子邮件。',
			invalidPassword:
				'密码必须至少包含 8 个字符，并且至少包含一个小写字母、一个大写字母、一个数字和一个特殊字符。',
			invalidParameter: '部分信息不正确或缺失。请检查您的信息并重试。',
			aliasExists:
				'此电子邮件或电话号码已与其他账户关联。请登录或使用其他信息。',
			limitExceeded: '已请求过多验证码。请稍等片刻后再试。',
			notAuthorized: '由于授权问题，我们无法处理您的注册。请稍后再试。',
			codeMismatch: '输入的验证码无效。请检查后重试。',
		},

		login: {
			userNotFound: '输入的电子邮件未注册。请检查是否有拼写错误或注册新账户。',
			notAuthorized:
				'登录失败。请检查您的凭据并重试。如果问题仍然存在，请联系我们。',
			invalidPassword: '您的凭据不正确。请检查后重试。',
			codeMismatch: '输入的验证码无效。请检查后重试。',
			userNotConfirmed:
				'您需要验证账户才能登录。请检查您的电子邮件或短信验证码。',
			passwordResetRequired:
				'请先重置您的密码，然后再登录。请按照发送至您电子邮件的说明操作。',
			expiredCode: '验证码已过期。请请求新的验证码并重试。',
		},

		resetPass: {
			userNotFound: '输入的电子邮件未注册。请检查是否有拼写错误或注册新账户。',
			invalidParameter: '某些必填信息不正确或缺失。请检查您的信息并重试。',
			notAuthorized: '身份验证失败，缺少安全参数。请重试或联系我们。',
			limitExceeded: '密码重置请求过多。请稍等片刻后再试。',
			internalError: '发生问题。请稍后再试。',
			invalidLambda: '无法处理您的请求。请稍后再试。',
			invalidSmsPolicy: '无法发送短信验证码。请稍后再试。',
			codeMismatch: '输入的验证码不正确。请检查后重试。',
			expiredCode: '输入的验证码已过期。请请求新的验证码并重试。',
			invalidPassword:
				'密码必须至少包含 8 个字符，并且至少包含一个小写字母、一个大写字母、一个数字和一个特殊字符。',
		},
	},
	errorsNotFound: {
		pageMissingTitle: '很抱歉！',
		pageMissingMessage: '您正在查找的页面可能已被删除。',
		pageMissingSupport: '请重新登录以重新验证身份。如需帮助，请联系我们。',
		goHome: '登录',
		contactUs: '联系我们',
	},
}
